webpackJsonp([2],{

/***/ "+Afb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-warning",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-chart text-warning"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Capacity")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("105GB")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Updated now\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-success",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-light-3 text-success"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Revenue")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("$1,345")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-calendar-o"}),_vm._v("Last day\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-danger",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-vector text-danger"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Errors")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("23")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v("Last day\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('stats-card',[_c('div',{staticClass:"icon-info",attrs:{"slot":"header"},slot:"header"},[_c('i',{staticClass:"nc-icon nc-favourite-28 text-primary"})]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"card-category"},[_vm._v("Followers")]),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("+45")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("Updated now\n          ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('chart-card',{attrs:{"chart-data":_vm.lineChart.data,"chart-options":_vm.lineChart.options,"responsive-options":_vm.lineChart.responsiveOptions}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("24 Hours performance")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n              "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n              "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n            ")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('chart-card',{attrs:{"chart-data":_vm.pieChart.data,"chart-type":"Pie"}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Email Statistics")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Last Campaign Performance")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n              "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Bounce\n              "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Unsubscribe\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Campaign sent 2 days ago\n            ")])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.barChart.data,"chart-options":_vm.barChart.options,"chart-responsive-options":_vm.barChart.responsiveOptions,"chart-type":"Bar"}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2014 Sales")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n              "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" BMW 5 Series\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Data information certified\n            ")])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('card',[_c('template',{slot:"header"},[_c('h5',{staticClass:"title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])]),_vm._v(" "),_c('l-table',{attrs:{"data":_vm.tableData.data,"columns":_vm.tableData.columns},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('td',[_c('Checkbox',{model:{value:(row.checked),callback:function ($$v) {_vm.$set(row, "checked", $$v)},expression:"row.checked"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.editTooltip),expression:"editTooltip",modifiers:{"top-center":true}}],staticClass:"btn-simple btn btn-xs btn-info",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.top-center",value:(_vm.deleteTooltip),expression:"deleteTooltip",modifiers:{"top-center":true}}],staticClass:"btn-simple btn btn-xs btn-danger",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-times"})])])]}}])},[_c('template',{slot:"columns"})],2),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n            ")])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+DXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: "https://cortassa.ideadinamica.it/api/" + 'lavorazione?withTrashed=true',
      lavorazioniColumns: [{
        key: 'lavorazione',
        text: 'Lavorazione'
      }],
      lavorazioniRowClass: function lavorazioniRowClass(data) {
        return data.deleted_at ? 'text-danger' : '';
      },
      lavorazioni: [],
      pattern: this.$route.params.pattern
    };
  },

  methods: {
    onClick: function onClick(data) {
      this.$root.$router.push('/dashboard/lavorazione/' + data.id);
    },
    newLavorazione: function newLavorazione() {
      this.$root.$router.push('/dashboard/lavorazione-new');
    }
  }
});

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "/2B0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  computed: {
    isAuth: function isAuth() {
      return this.$root.isAuth;
    }
  }
});

/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/cZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fg-input',{class:_vm.classObject,attrs:{"type":"text"},model:{value:(_vm.orario),callback:function ($$v) {_vm.orario=$$v},expression:"orario"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/sP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("e1sq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f788a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("iPOE");
function injectStyle (ssrContext) {
  __webpack_require__("ynVw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f788a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("lk2w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/z2V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4174bac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("Yt4Q");
function injectStyle (ssrContext) {
  __webpack_require__("xdlZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4174bac8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__Card_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0mfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__);
//
//
//
//
//
//
//
//
//
//
//
//



if (false) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.GMAPS_API_KEY
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      center: {
        lat: 40.748817,
        lng: -73.985428
      },
      options: {
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]
      }
    };
  }
});

/***/ }),

/***/ "0qU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__ = __webpack_require__("0mfy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f686d86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__ = __webpack_require__("QnVc");
function injectStyle (ssrContext) {
  __webpack_require__("eKKf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f686d86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "19OD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      objName: 'farmaco',
      backendPath: 'farmaco',
      defaultRedirect: '/dashboard/farmaco-list',
      new: false,
      id: null,
      saving: false,
      loading: true,
      readOnly: true,
      oggetto: {}
    };
  },

  computed: {
    dataInserimento: function dataInserimento() {
      if (typeof this.oggetto.created_at === 'string') {
        return this.oggetto.created_at.substr(0, 10);
      }
      return null;
    },
    dataEliminazione: function dataEliminazione() {
      if (typeof this.oggetto.deleted_at === 'string') {
        return this.oggetto.deleted_at.substr(0, 10);
      }
      return null;
    }
  },
  mounted: function mounted() {
    var me = this;
    if (me.$route.meta.new === true) {
      me.$data.new = true;
      me.$data.loading = false;
      me.$data.readOnly = false;
    } else {
      me.$data.id = me.$route.params.id;
      me.caricaDati();
    }
  },

  methods: {
    caricaDati: function caricaDati() {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'GET';
      var params = { withTrashed: true };
      var successFn = function successFn(data) {
        me.$data.loading = false;
        me.$data.oggetto = data;
      };
      var errorFn = function errorFn(message) {
        me.ajaxErrorFn(message);
        me.$root.$router.push(me.$data.defaultRedirect);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    modModifica: function modModifica() {
      this.$data.readOnly = false;
    },
    salva: function salva() {
      var me = this;
      me.$data.readOnly = true;
      me.$data.saving = true;
      var url;
      var method;
      if (me.$data.new === true) {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath;
        method = 'POST';
      } else {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '?withTrashed=true';
        method = 'PUT';
      }
      var params = me.$data.oggetto;
      var successFn = function successFn(data) {
        if (me.$data.new === true) {
          me.$data.id = data.id;
          me.$data.new = false;
        }
        me.$data.oggetto = data;
        me.$data.saving = false;
        me.$root.$router.push(me.$data.defaultRedirect);
        me.successMessage('Dati ' + me.toUpperFirst(me.$data.objName) + ' salvati');
      };
      var errorFn = function errorFn(message) {
        me.$data.readOnly = false;
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    disattiva: function disattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'DELETE';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' disattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    riattiva: function riattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '/restore';
      var method = 'PUT';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' riattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "1Cmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('b',{staticClass:"navbar-brand"},[_vm._v(_vm._s(_vm.routeName)+" ")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler navbar-toggler-right",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button","aria-controls":"navigation-index","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"navbar-toggler-bar burger-lines"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar burger-lines"}),_vm._v(" "),_c('span',{staticClass:"navbar-toggler-bar burger-lines"})]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item"},[(_vm.isAuth)?_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("\n            Log out\n          ")]):_c('router-link',{staticClass:"nav-link",attrs:{"to":"/login"}},[_vm._v("\n            Log in\n          ")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_ComboBox_vue__ = __webpack_require__("widG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_formGroupImage_vue__ = __webpack_require__("s73l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__ = __webpack_require__("SVjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__ = __webpack_require__("Ppbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__);








/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component('p-checkbox', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component('combo-box', __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_ComboBox_vue__["a" /* default */]);
    Vue.component('fg-image', __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Inputs_formGroupImage_vue__["a" /* default */]);
    Vue.component('vue-timepicker', __WEBPACK_IMPORTED_MODULE_5_vue2_timepicker___default.a);
    Vue.component('date-picker', __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker___default.a);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GlobalMixin_js__ = __webpack_require__("TCSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_dashboard_css__ = __webpack_require__("kD4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_dashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_dashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_css_color_css__ = __webpack_require__("sXk/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_css_color_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_css_color_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue

// Global mixin


// asset imports






// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
    Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
    Vue.mixin(__WEBPACK_IMPORTED_MODULE_5__GlobalMixin_js__["a" /* default */]);
  }
});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1499f926_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("1Cmo");
function injectStyle (ssrContext) {
  __webpack_require__("9Fxz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1499f926_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3+++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingPasswordChange_vue__ = __webpack_require__("tzbD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18bf5328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingPasswordChange_vue__ = __webpack_require__("iaKx");
function injectStyle (ssrContext) {
  __webpack_require__("JiFe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingPasswordChange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18bf5328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingPasswordChange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3+o3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true
    }
  },
  props: {
    link: {
      type: [String, Object],
      default: function _default() {
        return {
          name: '',
          path: '',
          icon: ''
        };
      }
    },
    tag: {
      type: String,
      default: 'router-link'
    }
  },
  methods: {
    hideSidebar: function hideSidebar() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "3QpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orario_vue__ = __webpack_require__("IoEn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77eefb26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orario_vue__ = __webpack_require__("/cZl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77eefb26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ffw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DipendenteList_vue__ = __webpack_require__("Jlal");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8d1448e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DipendenteList_vue__ = __webpack_require__("OivF");
function injectStyle (ssrContext) {
  __webpack_require__("yiiz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DipendenteList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8d1448e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DipendenteList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3wKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(link.name))])])}))],2),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"#"}},[_c('div',{staticClass:"logo-img"},[_c('img',{staticStyle:{"width":"200px","max-width":"200px"},attrs:{"src":"static/img/logo-esteso.png","alt":"DINAMICA"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3y94":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4GcF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagina non trovata")])]),_vm._v(" "),_c('p',[_vm._v("La pagina che stai cercando non esiste.")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4UWb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ortaggio_vue__ = __webpack_require__("4an6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339e12d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ortaggio_vue__ = __webpack_require__("dIf/");
function injectStyle (ssrContext) {
  __webpack_require__("PcDq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ortaggio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339e12d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ortaggio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4an6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      objName: 'ortaggio',
      backendPath: 'ortaggio',
      defaultRedirect: '/dashboard/ortaggio-list',
      new: false,
      id: null,
      saving: false,
      loading: true,
      readOnly: true,
      oggetto: {}
    };
  },

  computed: {
    dataInserimento: function dataInserimento() {
      if (typeof this.oggetto.created_at === 'string') {
        return this.oggetto.created_at.substr(0, 10);
      }
      return null;
    },
    dataEliminazione: function dataEliminazione() {
      if (typeof this.oggetto.deleted_at === 'string') {
        return this.oggetto.deleted_at.substr(0, 10);
      }
      return null;
    }
  },
  mounted: function mounted() {
    var me = this;
    if (me.$route.meta.new === true) {
      me.$data.new = true;
      me.$data.loading = false;
      me.$data.readOnly = false;
    } else {
      me.$data.id = me.$route.params.id;
      me.caricaDati();
    }
  },

  methods: {
    caricaDati: function caricaDati() {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'GET';
      var params = { withTrashed: true };
      var successFn = function successFn(data) {
        me.$data.loading = false;
        me.$data.oggetto = data;
      };
      var errorFn = function errorFn(message) {
        me.ajaxErrorFn(message);
        me.$root.$router.push(me.$data.defaultRedirect);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    modModifica: function modModifica() {
      this.$data.readOnly = false;
    },
    salva: function salva() {
      var me = this;
      me.$data.readOnly = true;
      me.$data.saving = true;
      var url;
      var method;
      if (me.$data.new === true) {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath;
        method = 'POST';
      } else {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '?withTrashed=true';
        method = 'PUT';
      }
      var params = me.$data.oggetto;
      var successFn = function successFn(data) {
        if (me.$data.new === true) {
          me.$data.id = data.id;
          me.$data.new = false;
        }
        me.$data.oggetto = data;
        me.$data.saving = false;
        me.$root.$router.push(me.$data.defaultRedirect);
        me.successMessage('Dati ' + me.toUpperFirst(me.$data.objName) + ' salvati');
      };
      var errorFn = function errorFn(message) {
        me.$data.readOnly = false;
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    disattiva: function disattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'DELETE';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' disattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    riattiva: function riattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '/restore';
      var method = 'PUT';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' riattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "4dWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',[_vm._l((_vm.menuItems),function(item){return (_vm.itemVisible(item))?_c('sidebar-link',{key:item.to,attrs:{"to":item.to}},[_c('i',{class:item.iconCls}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.text))])]):_vm._e()}),_vm._v(" "),_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"})],2),_vm._v(" "),_c('div',{staticClass:"main-panel",attrs:{"id":"main-panel"}},[_c('div',{staticStyle:{"position":"relative","height":"100%"}},[(this.$sidebar.showSidebar)?_c('div',{staticClass:"mask-dashboard-content",on:{"click":_vm.toggleSidebar}}):_vm._e(),_vm._v(" "),_c('top-navbar'),_vm._v(" "),_c('dashboard-content'),_vm._v(" "),_c('content-footer')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "58dg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707de114_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("4GcF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707de114_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5OC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Dati "+_vm._s(_vm.objName))]),_vm._v(" "),(_vm.oggetto.deleted_at)?_c('p',{staticClass:"card-category text-danger"},[_vm._v("Disattivato")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{attrs:{"type":"text","label":"Nome","placeholder":"Nome","disabled":_vm.readOnly},model:{value:(_vm.oggetto.nome),callback:function ($$v) {_vm.$set(_vm.oggetto, "nome", $$v)},expression:"oggetto.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{attrs:{"type":"text","label":"Cognome","placeholder":"Cognome","disabled":_vm.readOnly},model:{value:(_vm.oggetto.cognome),callback:function ($$v) {_vm.$set(_vm.oggetto, "cognome", $$v)},expression:"oggetto.cognome"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{attrs:{"type":"number","min":"0","label":"Paga oraria (€/h)","placeholder":"Paga oraria","disabled":_vm.readOnly},model:{value:(_vm.oggetto.paga_oraria),callback:function ($$v) {_vm.$set(_vm.oggetto, "paga_oraria", $$v)},expression:"oggetto.paga_oraria"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataInserimento),expression:"dataInserimento"}],attrs:{"type":"date","label":"Data inserimento","disabled":true},model:{value:(_vm.dataInserimento),callback:function ($$v) {_vm.dataInserimento=$$v},expression:"dataInserimento"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataEliminazione),expression:"dataEliminazione"}],attrs:{"type":"date","label":"Data eliminazione","disabled":true},model:{value:(_vm.dataEliminazione),callback:function ($$v) {_vm.dataEliminazione=$$v},expression:"dataEliminazione"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[(_vm.saving || !_vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                  Salva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.modModifica($event)}}},[_vm._v("\n                  Modifica\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && !_vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.disattiva($event)}}},[_vm._v("\n                  Disattiva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && _vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.riattiva($event)}}},[_vm._v("\n                  Riattiva\n                ")]):_vm._e()])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("FFvd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6K31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_vm._v(" "),_vm._t("addonLeft",[(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]),_vm._v(" "),(!_vm.value)?_c('div',{staticStyle:{"display":"flex"}},[(!_vm.disabled)?_c('label',{staticClass:"btn btn-default btn-file form-control",staticStyle:{"margin":"0px"}},[_vm._v("\n      Seleziona file\n      "),_c('input',_vm._b({staticClass:"form-control",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*;capture=camera","aria-describedby":"addon-right addon-left"},on:{"change":_vm.onFileChange}},'input',_vm.$attrs,false))]):_vm._e(),_vm._v(" "),(!_vm.disabled && _vm.isApp)?_c('label',{staticClass:"btn btn-default btn-file form-control",staticStyle:{"margin":"0px 0px 0px 10px"},on:{"click":function($event){$event.preventDefault();return _vm.scattaFoto()}}},[_vm._v("\n      Scatta foto\n    ")]):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('div',{staticClass:"form-control",attrs:{"disabled":""}},[_vm._v("\n      Nessun file\n    ")]):_vm._e()]):_c('div',[_c('label',[_c('button',{staticClass:"btn btn-info form-control",on:{"click":function($event){$event.preventDefault();return _vm.showImage($event)}}},[_vm._v("Visualizza")])]),_vm._v(" "),(!_vm.disabled)?_c('label',[_c('button',{staticClass:"btn btn-info form-control",on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v("Rimuovi")])]):_vm._e()]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",[(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6dqi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6obS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Resetta password")]),_vm._v(" "),(_vm.loading && !_vm.tokenVerificato)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),(_vm.tokenVerificato && !_vm.passwordModificata)?_c('form',{staticClass:"login-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('fg-input',{attrs:{"type":"password","label":"Nuova Password","placeholder":"Password","disabled":_vm.loading},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('fg-input',{attrs:{"type":"password","label":"Ripeti la password","placeholder":"Password","disabled":_vm.loading},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-info btn-fill float-right",attrs:{"type":"submit","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                    Salva\n                  ")])])])]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.messaggioErrore))]),_vm._v(" "),(_vm.passwordModificata)?_c('p',[_vm._v("La nuova password è stata salvata")]):_vm._e()])],2)],1)]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3",staticStyle:{"padding":"0px 30px"}},[_c('a',{attrs:{"href":"#/login"}},[_vm._v("Torna alla pagina di login")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "71xX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiepilogoCompensi_vue__ = __webpack_require__("vaMB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5053823c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiepilogoCompensi_vue__ = __webpack_require__("IX/m");
function injectStyle (ssrContext) {
  __webpack_require__("ky6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiepilogoCompensi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5053823c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiepilogoCompensi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "726C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__ = __webpack_require__("MsPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    VueScrollingTable: __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default.a
  },
  data: function data() {
    return {
      countCaricaGiorno: 0,
      saving: false,
      erroreSalvataggio: '',
      loading: true,
      loadingText: 'Caricamento in corso...',
      backendPath: 'trattamenti/report-giorno',
      giorno: null,
      farmaci: [],
      ortaggi: [],
      trattamento: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    var me = this;
    me.$data.giorno = me.todayToString();
  },

  watch: {
    giorno: function giorno(value) {
      var me = this;
      me.caricaGiorno(value);
    }
  },
  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    resettaData: function resettaData() {
      var me = this;
      me.$data.loading = true;
      me.$data.loadingText = 'Caricamento in corso...';
      me.$data.backendPath = 'trattamenti/report-giorno';
      me.$data.farmaci = [];
      me.$data.ortaggi = [];
      me.$data.trattamenti = [];
    },

    caricaGiorno: function caricaGiorno(giorno) {
      var me = this;
      me.resettaData();
      var countCaricaGiorno = ++me.$data.countCaricaGiorno;
      if (!giorno) {
        return;
      }
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + giorno;
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
          return;
        }
        var trattamento = {};
        for (var f in data.farmaci) {
          var idF = data.farmaci[f].id;
          trattamento[idF] = {};
          for (var o in data.ortaggi) {
            var idO = data.ortaggi[o].id;
            var d;
            if (typeof data.dosi[idF] === 'undefined' || typeof data.dosi[idF][idO] === 'undefined') {
              d = 0;
            } else {
              d = data.dosi[idF][idO];
            }
            trattamento[idF][idO] = d;
          }
        }
        me.$data.loading = false;
        me.$data.farmaci = data.farmaci;
        me.$data.ortaggi = data.ortaggi;
        me.$data.trattamento = trattamento;
      };
      var errorFn = function errorFn(message) {
        if (typeof message === 'undefined') {
          message = 'Network Error';
        }
        me.$data.loadingText = 'Errore: ' + message;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    salva: function salva() {
      var me = this;
      me.saving = true;
      me.erroreSalvataggio = '';
      var dosi = {};
      var giorno = me.$data.giorno;
      var trattamento = me.$data.trattamento;
      for (var idF in trattamento) {
        for (var idO in trattamento[idF]) {
          if (trattamento[idF][idO]) {
            var dose = parseInt(trattamento[idF][idO]);
            if (dose) {
              if (typeof dosi[idF] === 'undefined') {
                dosi[idF] = {};
              }
              dosi[idF][idO] = dose;
            }
          }
        }
      }
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + giorno;
      var method = 'PUT';
      var params = {
        dosi: dosi
      };
      var successFn = function successFn(data) {
        me.successMessage('Dati salvati');
        me.saving = false;
      };
      var errorFn = function errorFn(message) {
        if (typeof message === 'undefined') {
          message = 'Network Error';
        }
        me.$data.erroreSalvataggio = 'Errore: ' + message;
        me.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "7KYA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d09261_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("UvUG");
function injectStyle (ssrContext) {
  __webpack_require__("h0DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69d09261_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__("gCMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__("goRD");
function injectStyle (ssrContext) {
  __webpack_require__("IBYz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8BRT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Fxz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AKoQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AjY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserRecovery_vue__ = __webpack_require__("cdY8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f72c2a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserRecovery_vue__ = __webpack_require__("l1zh");
function injectStyle (ssrContext) {
  __webpack_require__("/z2V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserRecovery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f72c2a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserRecovery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AxoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Axzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__ = __webpack_require__("MsPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    VueScrollingTable: __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default.a
  },
  data: function data() {
    return {
      countCaricaGiorno: 0,
      erroreSalvataggio: '',
      loading: true,
      loadingText: 'Caricamento in corso...',
      backendPath: 'trattamenti/report-mese',
      giorno: null,
      farmaci: [],
      ortaggi: [],
      trattamento: [],
      monthFormat: {
        stringify: function stringify(date) {
          if (date instanceof Date) {
            var tzoffset = date.getTimezoneOffset() * 60000;
            var strDate = new Date(date.getTime() - tzoffset).toISOString().substr(0, 19).replace('T', ' ');
            var anno = strDate.substr(0, 4);
            var mese = parseInt(strDate.substr(5, 2)) - 1;
            var arrayMesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
            return arrayMesi[mese] + ' ' + anno;
          }
          return '';
        },
        parse: function parse(value) {
          if (typeof value === 'string') {
            var mmaa = value.trim().split(' ');
            if (mmaa.length !== 2) {
              return null;
            }
            var anno = mmaa[1];
            var arrayMesi = ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE'];
            var meseMenoUno = arrayMesi.indexOf(mmaa[0].toUpperCase());
            if (meseMenoUno !== -1) {
              var date = new Date();
              date.setMonth(meseMenoUno);
              date.setYear(anno);
              return date;
            }
          }
          return null;
        }
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    var me = this;
    me.$data.giorno = new Date();
  },

  watch: {
    giorno: function giorno(value) {
      var me = this;
      if (value instanceof Date && value.getTime()) {
        var mese = this.dateToString(value).substr(0, 7);
        me.caricaGiorno(mese);
      } else {
        me.resettaData();
      }
    }
  },
  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    resettaData: function resettaData() {
      var me = this;
      me.$data.loading = true;
      me.$data.loadingText = 'Caricamento in corso...';
      me.$data.backendPath = 'trattamenti/report-mese';
      me.$data.farmaci = [];
      me.$data.ortaggi = [];
      me.$data.trattamento = [];
    },

    caricaGiorno: function caricaGiorno(giorno) {
      var me = this;
      me.resettaData();
      var countCaricaGiorno = ++me.$data.countCaricaGiorno;
      if (!giorno) {
        return;
      }
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + giorno;
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
          return;
        }
        var trattamento = {};
        for (var f in data.farmaci) {
          var idF = data.farmaci[f].id;
          trattamento[idF] = {};
          for (var o in data.ortaggi) {
            var idO = data.ortaggi[o].id;
            if (data.dosi[idF] && data.dosi[idF][idO]) {
              trattamento[idF][idO] = data.dosi[idF][idO];
            }
          }
        }
        me.$data.loading = false;
        me.$data.farmaci = data.farmaci;
        me.$data.ortaggi = data.ortaggi;
        me.$data.trattamento = trattamento;
      };
      var errorFn = function errorFn(message) {
        if (typeof message === 'undefined') {
          message = 'Network Error';
        }
        me.$data.loadingText = 'Errore: ' + message;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    getTotaleOrtaggio: function getTotaleOrtaggio(idO) {
      var trattamento = this.$data.trattamento;
      var tot = 0;
      for (var idF in trattamento) {
        if (trattamento[idF][idO]) {
          tot += parseInt(trattamento[idF][idO]);
        }
      }
      return tot;
    },
    getTotaleFarmacoOrtaggio: function getTotaleFarmacoOrtaggio(idF, idO) {
      var trattamento = this.$data.trattamento;
      var tot = 0;
      if (trattamento[idF] && trattamento[idF][idO]) {
        tot = parseInt(trattamento[idF][idO]);
      }
      return tot;
    },
    generatePDF: function generatePDF() {
      var anno = this.$data.giorno.getFullYear();
      var mese = this.$data.giorno.getMonth() + 1;
      if (mese < 10) {
        mese = '0' + mese;
      }
      window.open('https://cortassa.ideadinamica.it/api/pdf/trattamenti/?date=' + anno + '-' + mese, '_blank');
      /* window.open('https://localhost/dinamica/cortassa/api/pdf/trattamenti/?date=' + anno + '-' + mese, '_blank') */
    }
  }
});

/***/ }),

/***/ "Btto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      objName: 'lavorazione',
      backendPath: 'lavorazione',
      defaultRedirect: '/dashboard/lavorazione-list',
      new: false,
      id: null,
      saving: false,
      loading: true,
      readOnly: true,
      oggetto: {}
    };
  },

  computed: {
    dataInserimento: function dataInserimento() {
      if (typeof this.oggetto.created_at === 'string') {
        return this.oggetto.created_at.substr(0, 10);
      }
      return null;
    },
    dataEliminazione: function dataEliminazione() {
      if (typeof this.oggetto.deleted_at === 'string') {
        return this.oggetto.deleted_at.substr(0, 10);
      }
      return null;
    }
  },
  mounted: function mounted() {
    var me = this;
    if (me.$route.meta.new === true) {
      me.$data.new = true;
      me.$data.loading = false;
      me.$data.readOnly = false;
    } else {
      me.$data.id = me.$route.params.id;
      me.caricaDati();
    }
  },

  methods: {
    caricaDati: function caricaDati() {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'GET';
      var params = { withTrashed: true };
      var successFn = function successFn(data) {
        me.$data.loading = false;
        me.$data.oggetto = data;
      };
      var errorFn = function errorFn(message) {
        me.ajaxErrorFn(message);
        me.$root.$router.push(me.$data.defaultRedirect);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    modModifica: function modModifica() {
      this.$data.readOnly = false;
    },
    salva: function salva() {
      var me = this;
      me.$data.readOnly = true;
      me.$data.saving = true;
      var url;
      var method;
      if (me.$data.new === true) {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath;
        method = 'POST';
      } else {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '?withTrashed=true';
        method = 'PUT';
      }
      var params = me.$data.oggetto;
      var successFn = function successFn(data) {
        if (me.$data.new === true) {
          me.$data.id = data.id;
          me.$data.new = false;
        }
        me.$data.oggetto = data;
        me.$data.saving = false;
        me.$root.$router.push(me.$data.defaultRedirect);
        me.successMessage('Dati ' + me.toUpperFirst(me.$data.objName) + ' salvati');
      };
      var errorFn = function errorFn(message) {
        me.$data.readOnly = false;
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    disattiva: function disattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'DELETE';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' disattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    riattiva: function riattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '/restore';
      var method = 'PUT';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' riattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [{
    name: 'Dashboard',
    icon: 'ti-panel',
    path: '/admin/overview'
  }],
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  }
};

var SidebarPlugin = {
  install: function install(Vue) {
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "DTOs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FFvd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FT6R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GjBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HEWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[(true)?_c('nav',[_c('ul',{staticClass:"footer-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_vm._v("Indietro")])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © Dinamica s.n.c. 2019\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HN8v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lavorazione_vue__ = __webpack_require__("Btto");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7192816a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lavorazione_vue__ = __webpack_require__("lBlu");
function injectStyle (ssrContext) {
  __webpack_require__("ZZLa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lavorazione_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7192816a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lavorazione_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HQ3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_vm._t("columns",_vm._l((_vm.columns),function(column){return _c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.showColumn(column)),expression:"showColumn(column)"}],class:[_vm.thClass(column)],on:{"click":function($event){return _vm.sortBy(column)}}},[(column==_vm.sortColumn)?_c('i',{class:['fa',{'fa-long-arrow-down': _vm.sortDir==1,'fa-long-arrow-up': _vm.sortDir!=1}]}):_vm._e(),_vm._v("\n        "+_vm._s(column.text)+"\n        ")])}))],2)]),_vm._v(" "),_c('tfoot',[(_vm.loading)?_c('tr',[_c('td',{attrs:{"colspan":_vm.columns.length}},[_c('center',[_c('p',{staticClass:"card-category"},[_vm._v("Caricamento in corso...")])])],1)]):_vm._e()]),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(item){return (_vm.showItem(item))?_c('tr',{class:[_vm.trClass(item)]},[_vm._t("default",_vm._l((_vm.columns),function(column){return _c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showColumn(column)),expression:"showColumn(column)"}],class:[_vm.tdClass(item,column)],on:{"click":function($event){return _vm.itemClick(item,column)}}},[(column.renderAsHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.itemValue(item, column))}}):_c('div',{domProps:{"textContent":_vm._s(_vm.itemValue(item, column))}})])}),{"row":item})],2):_vm._e()}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HSIw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IAHV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LavorazioneList_vue__ = __webpack_require__("+DXZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d608a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LavorazioneList_vue__ = __webpack_require__("S3aU");
function injectStyle (ssrContext) {
  __webpack_require__("FT6R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LavorazioneList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d608a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LavorazioneList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IBYz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IX/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Riepilogo compensi")]),_vm._v(" "),_c('button',{staticClass:"btnPrint",on:{"click":function($event){return _vm.generatePDF()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" Stampa tutti")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    Mese\n                  ")]),_vm._v(" "),_c('date-picker',{staticClass:"riepilogo-mensile-date-picker",attrs:{"type":"month","lang":"it","clearable":false,"value-type":"date","format":_vm.monthFormat,"label":"Giorno"},model:{value:(_vm.giorno),callback:function ($$v) {_vm.giorno=$$v},expression:"giorno"}})],1)])])]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v(_vm._s(_vm.loadingText))])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-ore-lavoro-mensili",style:({'max-width':'100%','max-height':Math.max(200,_vm.window.height-200)+'px'})},[_c('vue-scrolling-table',{staticClass:"table",attrs:{"deadAreaColor":"#FFF"}},[_c('template',{slot:"thead"},[_c('tr',[_c('th',{staticStyle:{"width":"200px !important","min-width":"200px !important","max-width":"200px !important"}}),_vm._v(" "),_vm._l((_vm.lavorazioni),function(lav){return _c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_c('button',{staticClass:"btnPrint",on:{"click":function($event){return _vm.generatePDFLavorazioni(lav)}}},[_c('i',{staticClass:"fa fa-print"})]),_c('br'),_vm._v(" "+_vm._s(lav.lavorazione))])}),_vm._v(" "),_c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_c('b',[_vm._v("Totale")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_c('b',[_vm._v("Paga oraria")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_c('b',[_vm._v("Acconto")])]),_vm._v(" "),_c('th',{staticStyle:{"width":"140px !important","min-width":"140px !important","max-width":"140px !important"}},[_c('b',[_vm._v("Compenso")])])],2)]),_vm._v(" "),_c('template',{slot:"tbody"},[_vm._l((_vm.dipendenti),function(dip){return _c('tr',[_c('td',{staticStyle:{"width":"200px !important","min-width":"200px !important","max-width":"200px !important"}},[_c('button',{staticClass:"btnPrint",on:{"click":function($event){return _vm.generatePDF(dip)}}},[_c('i',{staticClass:"fa fa-print"})]),_vm._v(" "+_vm._s(dip.nome)+" "+_vm._s(dip.cognome))]),_vm._v(" "),_vm._l((_vm.lavorazioni),function(lav){return _c('td',{staticClass:"ore-lavoro-mensili",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v("\n                      "+_vm._s(_vm.getTotaleDipLav(dip.id, lav.id))+"\n                    ")])}),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getTotaleDipendente(dip.id)))]),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-paga-oraria",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.numberToString(dip.paga_oraria, 2))+" €/h")]),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getAccontiString(dip)))]),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"140px !important","min-width":"140px !important","max-width":"140px !important"}},[_vm._v(_vm._s(_vm.getCompensoDipendenteString(dip)))])],2)}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}},[_c('b',[_vm._v("Totale")])]),_vm._v(" "),_vm._l((_vm.lavorazioni),function(lav){return _c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getTotaleLavorazione(lav.id)))])}),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getTotaleGenerale()))]),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}}),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}}),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-mensili-totali",staticStyle:{"width":"140px !important","min-width":"140px !important","max-width":"140px !important"}},[_vm._v(_vm._s(_vm.getTotaleCompensi()))])],2)],2)],2)],1)]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IoEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value'],
  data: function data() {
    return {
      orario: this.format(this.value),
      classObject: this.class
    };
  },

  watch: {
    orario: function orario(newValue) {
      this.orario = this.format(newValue);
      this.$emit('input', this.orario);
    }
  },
  methods: {
    format: function format(v) {
      if (typeof v === 'string' && (v.indexOf(':') !== -1 || v.indexOf('.') !== -1 || v.indexOf(',') !== -1)) {
        v = v.replace('.', ':').replace(',', ':');
        var array = v.split(':');
        v = (parseInt(array[0]) || 0) + ':';
        if (array[1]) {
          v += array[1].replace(/\D/g, '');
        }
      } else {
        v = v.replace(/\D/g, '');
      }
      if (v === '0:00') {
        v = '';
      }
      return v;
    }
  }
});

/***/ }),

/***/ "JiFe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jjqc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jlal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: "https://cortassa.ideadinamica.it/api/" + 'dipendente?withTrashed=true',
      dipendentiColumns: [{
        key: 'nome',
        text: 'Nome'
      }, {
        key: 'cognome',
        text: 'Cognome'
      }, {
        key: 'paga_oraria',
        text: 'Paga oraria',
        renderer: function renderer(record) {
          var str = this.numberToString(record.paga_oraria);
          if (str !== '') {
            str += ' €/h';
          }
          return str;
        },
        getCellClass: function getCellClass(item) {
          return 'dashboard-align-right';
        },
        getHeaderClass: function getHeaderClass() {
          return 'dashboard-align-right';
        }
      }],
      dipendentiRowClass: function dipendentiRowClass(data) {
        return data.deleted_at ? 'text-danger' : '';
      },
      dipendenti: [],
      pattern: this.$route.params.pattern
    };
  },

  methods: {
    onClick: function onClick(data) {
      this.$root.$router.push('/dashboard/dipendente/' + data.id);
    },
    newDipendente: function newDipendente() {
      this.$root.$router.push('/dashboard/dipendente-new');
    }
  }
});

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L/ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L3AE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L3h3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trattamenti_vue__ = __webpack_require__("726C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b41659c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trattamenti_vue__ = __webpack_require__("lV5w");
function injectStyle (ssrContext) {
  __webpack_require__("DTOs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Trattamenti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b41659c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Trattamenti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eedf2cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("L/ta");
function injectStyle (ssrContext) {
  __webpack_require__("MTLC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eedf2cf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  computed: {
    isAuth: function isAuth() {
      return this.$root.isAuth;
    }
  },
  methods: {
    logout: function logout() {
      this.$root.logout();
      this.hideSidebar();
    },
    hideSidebar: function hideSidebar() {
      if (this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "MTLC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MXdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Riepilogo trattamenti")]),_vm._v(" "),_c('button',{staticClass:"btnPrint",on:{"click":function($event){return _vm.generatePDF()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" Stampa tutti")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    Mese\n                  ")]),_vm._v(" "),_c('date-picker',{staticClass:"riepilogo-mensile-date-picker",attrs:{"type":"month","lang":"it","clearable":false,"value-type":"date","format":_vm.monthFormat,"label":"Giorno"},model:{value:(_vm.giorno),callback:function ($$v) {_vm.giorno=$$v},expression:"giorno"}})],1)])])]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v(_vm._s(_vm.loadingText))])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-trattamenti-mensili",style:({'max-width':'100%','max-height':Math.max(200,_vm.window.height-200)+'px'})},[_c('vue-scrolling-table',{staticClass:"table",attrs:{"deadAreaColor":"#FFF"}},[_c('template',{slot:"thead"},[_c('tr',[_c('th',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}}),_vm._v(" "),_vm._l((_vm.ortaggi),function(ortaggio){return _c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(ortaggio.nome))])})],2)]),_vm._v(" "),_c('template',{slot:"tbody"},_vm._l((_vm.farmaci),function(farmaco){return _c('tr',[_c('td',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}},[_vm._v(_vm._s(farmaco.nome))]),_vm._v(" "),_vm._l((_vm.ortaggi),function(ortaggio){return _c('td',{staticClass:"trattamenti-mensili",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v("\n                      "+_vm._s(_vm.getTotaleFarmacoOrtaggio(farmaco.id, ortaggio.id))+"\n                    ")])})],2)}),0)],2)],1)]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c562d8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("HEWr");
function injectStyle (ssrContext) {
  __webpack_require__("8BRT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c562d8d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: 'static/img/sidebar2.jpg'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide: function provide() {
    return {
      autoClose: this.autoClose
    };
  },

  computed: {
    sidebarStyle: function sidebarStyle() {
      return {
        backgroundImage: 'url(' + this.backgroundImage + ')'
      };
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cordova__ = __webpack_require__("LX+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cordova___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cordova__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__light_bootstrap_main__ = __webpack_require__("28ys");




// import VueLocalStorage from 'vue-localstorage'




// LightBootstrap plugin


// plugin setup
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
// Vue.use(VueLocalStorage)
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default.a, { dynamic: true, injectModalsContainer: true });
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_cordova___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7__light_bootstrap_main__["a" /* default */]);

var isApp = document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1;
if (isApp) {
  var scriptCordova = document.createElement('script');
  scriptCordova.type = 'text/javascript';
  scriptCordova.src = 'cordova.js';
  document.getElementsByTagName('head')[0].appendChild(scriptCordova);
}

// Codice barra dei cookie - Inizio
var scriptCookie = document.createElement('script');
scriptCookie.id = 'Cookiebot';
scriptCookie.src = 'https://consent.cookiebot.com/uc.js';
scriptCookie.setAttribute('data-cbid', 'fb8788e6-7561-429e-a2ca-593a31300cc9');
scriptCookie.type = 'text/javascript';
document.getElementsByTagName('head')[0].appendChild(scriptCookie);
// Codice barra dei cookie - Fine

// configure router
var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  // routes, // short for routes: routes, lo eseguo nel file GlobalMixin
  linkActiveClass: 'nav-item active',
  base: "/"
});

var scrollableElementId = 'main-panel'; // You should change this
var scrollPositions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);

window.addEventListener('popstate', function () {
  var currentRouteName = router.history.current.name;

  var element = document.getElementById(scrollableElementId);
  if (element !== null && currentRouteName in scrollPositions) {
    var scrollFn = function scrollFn() {
      element.scrollTop = scrollPositions[currentRouteName];
    };
    setTimeout(scrollFn, 100);
    setTimeout(scrollFn, 300);
  }
});

router.beforeEach(function (to, from, next) {
  var element = document.getElementById(scrollableElementId);
  if (element !== null) {
    scrollPositions[from.name] = element.scrollTop;
    element.scrollTop = 0;
  }
  if (to.matched.some(function (record) {
    return record.path === '/login';
  })) {
    if (vm.isAuth) {
      next({
        path: '/dashboard/home'
      });
      return;
    }
  }
  if (to.matched.some(function (record) {
    return record.path === '/dashboard/home';
  })) {
    if (!vm.isAuth) {
      next({
        path: '/login'
      });
      return;
    }
  }
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth || record.meta.requiresAuthType;
  })) {
    if (!vm.isAuth) {
      next({
        path: '/notauthorized'
      });
    } else {
      for (var i in to.matched) {
        var arrayType = to.matched[i].meta.requiresAuthType;
        if (!vm.checkAuthType(arrayType)) {
          next({
            path: '/notauthorized'
          });
          return;
        }
      }
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_2_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App_vue__["a" /* default */]);
  },
  router: router,
  data: {
    user: null,
    isApp: isApp,
    cordova: __WEBPACK_IMPORTED_MODULE_2_vue___default.a.cordova
  },
  computed: {
    isAuth: function isAuth() {
      if (this.user) {
        return true;
      }
      return false;
    }
  },
  methods: {}
});

vm.checkLogin();

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OR9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Farmaco_vue__ = __webpack_require__("19OD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c0ce98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Farmaco_vue__ = __webpack_require__("gVeh");
function injectStyle (ssrContext) {
  __webpack_require__("3+o3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Farmaco_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c0ce98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Farmaco_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_vue__ = __webpack_require__("jEp+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2__Card_vue__["a" /* default */]
  },
  props: {
    loading: Boolean,
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    },
    responsiveOptions: [Object, Array]
  },
  data: function data() {
    return {
      chartistImported: false,
      chartId: 'no-id',
      $Chartist: null,
      chart: null
    };
  },

  methods: {
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions, this.responsiveOptions);
      this.$emit('initialized', this.chart);
      if (this.chartType === 'Line') {
        this.animateLineChart();
      }
      if (this.chartType === 'Bar') {
        this.animateBarChart();
      }
    },

    /***
     * Assigns a random id to the chart
     */
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    animateLineChart: function animateLineChart() {
      var _this = this;

      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: _this.$Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === 'point') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
      seq = 0;
    },
    animateBarChart: function animateBarChart() {
      var seq = 0;
      var durations = 500;
      var delays = 80;
      this.chart.on('draw', function (data) {
        if (data.type === 'bar') {
          seq++;
          data.element.animate({
            opacity: {
              begin: seq * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: 'ease'
            }
          });
        }
      });
    }
  },
  watch: {
    loading: function loading() {
      if (!this.$data.loading && this.$data.chartistImported) {
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this2.$Chartist = Chartist;
              _this2.$data.chartistImported = true;
              if (!_this2.$data.loading) {
                _this2.initChart();
              }

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ "OivF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Dipendenti")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"","placeholder":"Cerca..."},model:{value:(_vm.pattern),callback:function ($$v) {_vm.pattern=$$v},expression:"pattern"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 table-responsive"},[_c('l-table',{staticClass:"table-hover table-striped",attrs:{"columns":_vm.dipendentiColumns,"data":_vm.dipendenti,"url":_vm.url,"pattern":_vm.pattern,"getRowClass":_vm.dipendentiRowClass},on:{"onClick":_vm.onClick}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.newDipendente($event)}}},[_vm._v("\n                Nuovo Dipendente\n              ")])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3988f6ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("WOE+");
function injectStyle (ssrContext) {
  __webpack_require__("fuBC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3988f6ab_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OoYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'fg-image',
  data: function data() {
    return {
      visualizzaImg: false,
      changed: false
    };
  },

  props: {
    disabled: Boolean,
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String
  },
  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var _this = this;

      var reader = new FileReader();
      var me = this;
      reader.onload = function (e) {
        _this.$data.changed = true;
        me.$emit('input', e.target.result);
      };
      reader.readAsDataURL(file);
    },

    showImage: function showImage(e) {
      var src;
      if (this.$data.changed) {
        src = this.$props.value;
      } else {
        src = this.$root.imgUrl(this.$props.value);
      }
      this.$root.showModal('<div style="width:100%;height:100%;overflow:auto;text-align:center; padding:5px;"><img :src="value" width="100%"/></div>', {
        value: src
      });
    },
    removeImage: function removeImage(e) {
      this.$emit('input', '');
    },
    scattaFoto: function scattaFoto() {
      var me = this;
      var camera = me.$root.cordova.camera;
      camera.getPicture(function (imageData) {
        var data = 'data:image/jpeg;base64,' + imageData;
        me.$data.changed = true;
        me.$emit('input', data);
      }, function (message) {
        me.$root.errorMessage('Errore fotocamera: ', message);
      }, {
        quality: 50,
        destinationType: camera.DestinationType.DATA_URL
      });
    }
  },
  computed: {
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    },
    isApp: function isApp() {
      return this.$root.isApp;
    }
  }
});

/***/ }),

/***/ "PcDq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card'
});

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'l-table',
  props: {
    parent: Object,
    url: String,
    columns: Array, // possible keys: key, text, renderer (function), getCellClass (function), getHeaderClass (function)
    getRowClass: Function,
    data: Array,
    pattern: String
  },
  data: function data() {
    return {
      rows: [],
      loading: false,
      sortColumn: null,
      sortDir: 1
    };
  },
  mounted: function mounted() {
    if (this.$props.url) {
      this.ajaxLoad();
    } else {
      this.rows = this.data;
    }
  },

  watch: {
    url: function url(value) {
      if (value) {
        this.ajaxLoad();
      }
    }
  },
  methods: {
    getParent: function getParent() {
      return this.$props.parent ? this.$props.parent : this.$parent;
    },
    showItem: function showItem(item) {
      if (!this.pattern) {
        return true;
      }
      var words = this.pattern.split(/\W+/);
      for (var i = 0; i < words.length; ++i) {
        if (words[i].length > 0) {
          var trovata = false;
          var parola = words[i].toUpperCase();
          for (var j = 0; j < this.columns.length; ++j) {
            var txt = '';
            if (typeof this.columns[j].renderer === 'function') {
              txt = this.columns[j].renderer.apply(this.getParent(), [item]);
            } else {
              txt = item[this.columns[j].key];
            }
            if (typeof txt === 'string') {
              var testo = txt.toUpperCase();
              if (testo.indexOf(parola) !== -1) {
                trovata = true;
              }
            }
          }
          if (!trovata) {
            return false;
          }
        }
      }
      return true;
    },

    showColumn: function showColumn(column) {
      if (typeof column.show === 'undefined') {
        return true;
      }
      if (typeof column.show === 'function') {
        return column.show.apply(this.getParent(), []);
      }
      return column.show;
    },
    itemValue: function itemValue(item, column) {
      return typeof column.renderer === 'function' ? column.renderer.apply(this.getParent(), [item]) : item[column.key];
    },
    trClass: function trClass(item) {
      return typeof this.getRowClass === 'function' ? this.getRowClass(item) : '';
    },
    tdClass: function tdClass(item, column) {
      return typeof column.getCellClass === 'function' ? column.getCellClass(item) : '';
    },
    thClass: function thClass(column) {
      return typeof column.getHeaderClass === 'function' ? column.getHeaderClass() : '';
    },
    sortBy: function sortBy(column) {
      var me = this;
      if (me.sortColumn === column) {
        me.sortDir *= -1;
      } else {
        me.sortColumn = column;
        me.sortDir = 1;
      }
      var sortFn = function sortFn(a, b) {
        var valA = me.sortColumn.key ? a[me.sortColumn.key] : me.itemValue(a, me.sortColumn);
        var valB = me.sortColumn.key ? b[me.sortColumn.key] : me.itemValue(b, me.sortColumn);
        if (typeof valA === 'undefined' || valA === null) {
          valA = '';
        }
        if (typeof valB === 'undefined' || valB === null) {
          valB = '';
        }
        if (valA === '' && valB !== '') return me.sortDir * -1;
        if (valA !== '' && valB === '') return me.sortDir;
        if (valA < valB) return me.sortDir * -1;
        if (valA > valB) return me.sortDir;
        return 0;
      };
      this.rows.sort(sortFn);
    },

    itemClick: function itemClick(item, column) {
      this.$emit('onClick', item, column);
    },
    ajaxLoad: function ajaxLoad() {
      var me = this;
      me.loading = true;
      var url = me.url;
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        me.loading = false;
        me.rows = data;
      };
      var errorFn = function errorFn(message) {
        me.loading = false;
        me.ajaxErrorFn(message);
      };
      me.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "QnVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{attrs:{"id":"map","center":_vm.center,"zoom":13,"options":_vm.options,"map-type-id":"terrain"}},[_c('gmap-marker',{attrs:{"position":_vm.center}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776a4d10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("3wKL");
function injectStyle (ssrContext) {
  __webpack_require__("L3AE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776a4d10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S3aU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Lavorazioni")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"","placeholder":"Cerca..."},model:{value:(_vm.pattern),callback:function ($$v) {_vm.pattern=$$v},expression:"pattern"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 table-responsive"},[_c('l-table',{staticClass:"table-hover table-striped",attrs:{"columns":_vm.lavorazioniColumns,"data":_vm.lavorazioni,"url":_vm.url,"pattern":_vm.pattern,"getRowClass":_vm.lavorazioniRowClass},on:{"onClick":_vm.onClick}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.newLavorazione($event)}}},[_vm._v("\n                Nuova Lavorazione\n              ")])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GeneralViews_NotAuthorized_vue__ = __webpack_require__("lsyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GeneralViews_LogIn_vue__ = __webpack_require__("fkBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GeneralViews_UserRecovery_vue__ = __webpack_require__("AjY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GeneralViews_PasswordReset_vue__ = __webpack_require__("Xqzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Setting_vue__ = __webpack_require__("mkZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_DipendenteList_vue__ = __webpack_require__("3ffw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Dipendente_vue__ = __webpack_require__("U38g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_LavorazioneList_vue__ = __webpack_require__("IAHV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Lavorazione_vue__ = __webpack_require__("HN8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Home_vue__ = __webpack_require__("/sP1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_OreLavoro_vue__ = __webpack_require__("nRCt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_RiepilogoCompensi_vue__ = __webpack_require__("71xX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Trattamenti_vue__ = __webpack_require__("L3h3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_RiepilogoTrattamenti_vue__ = __webpack_require__("aGhG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_FarmacoList_vue__ = __webpack_require__("fvpz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Farmaco_vue__ = __webpack_require__("OR9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_OrtaggioList_vue__ = __webpack_require__("ryos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Ortaggio_vue__ = __webpack_require__("4UWb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_OldViews_Overview_vue__ = __webpack_require__("bPm7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_OldViews_Typography_vue__ = __webpack_require__("jOBa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_OldViews_Maps_vue__ = __webpack_require__("0qU5");

// GeneralViews






// Dashboard pages



















var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/dashboard/home'
}, {
  path: '/dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/dashboard/home',
  children: [{
    path: 'home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Home_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'ore-lavoro',
    name: 'Ore di lavoro',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_OreLavoro_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'riepilogo-compensi',
    name: 'Riepilogo compensi',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_RiepilogoCompensi_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'trattamenti',
    name: 'Trattamenti',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Trattamenti_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'riepilogo-trattamenti',
    name: 'Riepilogo trattamenti',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_RiepilogoTrattamenti_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'dipendente-list',
    name: 'Elenco dipendenti',
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_DipendenteList_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    },
    children: [{
      path: ':pattern'
    }]
  }, {
    path: 'dipendente-new',
    name: 'Nuovo dipendente',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Dipendente_vue__["a" /* default */],
    meta: {
      requiresAuth: true,
      new: true
    }
  }, {
    path: 'dipendente/:id',
    name: 'Dipendente',
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Dipendente_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'lavorazione-list',
    name: 'Elenco lavorazioni',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_LavorazioneList_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    },
    children: [{
      path: ':pattern'
    }]
  }, {
    path: 'lavorazione-new',
    name: 'Nuova lavorazione',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Lavorazione_vue__["a" /* default */],
    meta: {
      requiresAuth: true,
      new: true
    }
  }, {
    path: 'lavorazione/:id',
    name: 'Lavorazione',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Lavorazione_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'ortaggio-list',
    name: 'Elenco ortaggi',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_OrtaggioList_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    },
    children: [{
      path: ':pattern'
    }]
  }, {
    path: 'ortaggio-new',
    name: 'Nuovo ortaggio',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Ortaggio_vue__["a" /* default */],
    meta: {
      requiresAuth: true,
      new: true
    }
  }, {
    path: 'ortaggio/:id',
    name: 'Ortaggio',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Ortaggio_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'setting',
    name: 'Impostazioni',
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Setting_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'farmaco-list',
    name: 'Elenco farmaci',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_FarmacoList_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    },
    children: [{
      path: ':pattern'
    }]
  }, {
    path: 'farmaco-new',
    name: 'Nuovo farmaco',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Farmaco_vue__["a" /* default */],
    meta: {
      requiresAuth: true,
      new: true
    }
  }, {
    path: 'farmaco/:id',
    name: 'Farmaco',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Farmaco_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: 'overview',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_OldViews_Overview_vue__["a" /* default */],
    meta: {
      requiresAuthType: ['A']
    }
  }, {
    path: 'typography',
    name: 'Typography',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_OldViews_Typography_vue__["a" /* default */],
    meta: {
      requiresAuthType: ['A']
    }
  }, {
    path: 'maps',
    name: 'Maps',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_OldViews_Maps_vue__["a" /* default */],
    meta: {
      requiresAuthType: ['A']
    }
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  children: [{
    path: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_GeneralViews_LogIn_vue__["a" /* default */]
  }, {
    path: 'user-recovery',
    component: __WEBPACK_IMPORTED_MODULE_4__components_GeneralViews_UserRecovery_vue__["a" /* default */]
  }, {
    path: 'password-reset',
    component: __WEBPACK_IMPORTED_MODULE_5__components_GeneralViews_PasswordReset_vue__["a" /* default */]
  }, {
    path: 'notauthorized',
    component: __WEBPACK_IMPORTED_MODULE_2__components_GeneralViews_NotAuthorized_vue__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */]
  }]
}];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "TCSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


// router setup



var GlobalMixin = {
  methods: {
    imgUrl: function imgUrl(id) {
      return "https://cortassa.ideadinamica.it/api/" + 'file/' + id;
    },
    ajax: function ajax(url, method, params, successFn, errorFn) {
      var me = this;
      var onSuccess = typeof successFn === 'undefined' ? function (data) {} : successFn;
      var onError = typeof errorFn === 'undefined' ? me.ajaxErrorFn : errorFn;
      var config = {
        url: url,
        method: typeof method === 'undefined' ? 'GET' : method,
        withCredentials: true
      };
      if (!params) {
        params = {};
      }
      if (config.method === 'GET') {
        config.params = params;
      } else {
        config.data = params;
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default()(config).then(function (response) {
        if (me.respSuccess(response)) {
          onSuccess(me.respData(response));
        } else {
          onError(me.respMessage(response));
        }
      }).catch(function (e) {
        onError(me.errorMessage(e.message));
      });
    },
    ajaxErrorFn: function ajaxErrorFn(message) {
      this.errorMessage('Errore', message);
    },
    /* Funzioni per l'autenticazione */
    login: function login(username, password, stayConnected, addCallBack) {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + 'auth/login';
      var method = 'POST';
      var params = {
        username: username,
        password: password,
        stayConnected: stayConnected
      };
      var successFn = function successFn(data) {
        me.$root.$data.user = data.user;
        me.$root.$router.push('/');
        me.successMessage('Benvenuto ' + me.$root.$data.user.username);
        if (typeof addCallBack === 'function') {
          addCallBack(true);
        }
      };
      var errorFn = function errorFn(message) {
        me.$root.$data.user = null;
        me.errorMessage('Errore', message);
        if (typeof addCallBack === 'function') {
          addCallBack(false);
        }
      };
      me.ajax(url, method, params, successFn, errorFn);
    },
    logout: function logout() {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + 'auth/logout';
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        me.$root.$data.user = null;
        me.successMessage('Log out avvenuto correttamente');
        me.$root.$router.push('/login');
      };
      var errorFn = function errorFn(message) {
        me.$root.$data.user = null;
        me.successMessage('Log out avvenuto correttamente');
        me.$root.$router.push('/login');
      };
      me.ajax(url, method, params, successFn, errorFn);
    },
    checkLogin: function checkLogin() {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + 'auth/check';
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        me.$root.$data.user = data.user;
        me.successMessage('Benvenuto ' + me.$root.$data.user.username);
        me.$root.$router.addRoutes(__WEBPACK_IMPORTED_MODULE_2__routes_routes__["a" /* default */]);
      };
      var errorFn = function errorFn(message) {
        me.$root.$data.user = null;
        me.$root.$router.addRoutes(__WEBPACK_IMPORTED_MODULE_2__routes_routes__["a" /* default */]);
      };
      me.ajax(url, method, params, successFn, errorFn);
    },
    checkAuthType: function checkAuthType(arrayType) {
      var me = this;
      var loggedUserType = me.$root.$data.user.type;
      if (typeof arrayType !== 'undefined') {
        if (typeof arrayType === 'string') {
          arrayType = [arrayType];
        }
        if (!arrayType.some(function (record) {
          return record === loggedUserType;
        })) {
          return false;
        }
      }
      return true;
    },
    /* Funzioni di elaborazione risposta dal server */
    respSuccess: function respSuccess(response) {
      if (response && response.data && response.data.result === 'success') {
        return true;
      } else {
        return false;
      }
    },
    respData: function respData(response) {
      if (response && response.data) {
        return response.data.data;
      }
    },
    respMessage: function respMessage(response) {
      if (response && response.data) {
        return response.data.message;
      }
    },
    /* funzioni per visualizzare le notifiche */
    errorMessage: function errorMessage(title, message) {
      this.$notify({
        type: 'danger',
        icon: 'fa fa-exclamation-circle',
        title: title || '',
        message: message || '',
        horizontalAlign: 'center',
        verticalAlign: 'bottom'
      });
    },
    successMessage: function successMessage(title, message) {
      this.$notify({
        type: 'success',
        icon: 'fa fa-check-circle',
        title: title || '',
        message: message || '',
        horizontalAlign: 'center',
        verticalAlign: 'bottom'
      });
    },
    dateToString: function dateToString(date) {
      var tzoffset = date.getTimezoneOffset() * 60000;
      return new Date(date.getTime() - tzoffset).toISOString().substr(0, 19).replace('T', ' ');
    },
    todayToString: function todayToString() {
      return this.dateToString(new Date()).substr(0, 10);
    },
    toUpperFirst: function toUpperFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatDate: function formatDate(date) {
      if ((typeof date === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(date)) === 'object' && date instanceof Date) {
        date = this.dateToString(date);
      }
      if (typeof date === 'string') {
        if (date.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
          return date.substr(8, 2) + '/' + date.substr(5, 2) + '/' + date.substr(0, 4);
        }
      }
      return '';
    },
    numberToString: function numberToString(number, decimals) {
      if (typeof number !== 'number') {
        return '';
      }
      if (typeof decimals === 'undefined') {
        decimals = 2;
      }
      return number.toFixed(decimals).replace('.', ',').replace(/\d(?=(\d{3})+,)/g, '$&.');
    },
    showModal: function showModal(template, props, modalParameters, eventListeners) {
      if (typeof props === 'undefined') {
        props = {};
      }
      if (typeof modalParameters === 'undefined') {
        modalParameters = {};
      }
      if (typeof eventListeners === 'undefined') {
        eventListeners = {};
      }
      modalParameters.height = '85%';
      modalParameters.width = '85%';
      this.$modal.show({
        template: template,
        props: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(props)
      }, props, modalParameters, eventListeners);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalMixin);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      menuItems: [{
        to: '/dashboard/home',
        text: 'Home',
        iconCls: 'fa fa-home',
        requiresAuth: false
      }, {
        to: '/dashboard/ore-lavoro',
        text: 'Ore di lavoro',
        iconCls: 'fa fa-clock-o',
        requiresAuth: true
      }, {
        to: '/dashboard/riepilogo-compensi',
        text: 'Riepilogo compensi',
        iconCls: 'fa fa-calendar-o',
        requiresAuth: true
      }, {
        to: '/dashboard/trattamenti',
        text: 'Trattamenti',
        iconCls: 'fa fa-paste',
        requiresAuth: true
      }, {
        to: '/dashboard/riepilogo-trattamenti',
        text: 'Riepilogo trattamenti',
        iconCls: 'fa fa-calendar-o',
        requiresAuth: true
      }, {
        to: '/dashboard/dipendente-list',
        text: 'Dipendenti',
        iconCls: 'fa fa-users',
        requiresAuth: true
      }, {
        to: '/dashboard/lavorazione-list',
        text: 'Lavorazioni',
        iconCls: 'fa fa-tasks',
        requiresAuth: true
      }, {
        to: '/dashboard/farmaco-list',
        text: 'Farmaci',
        iconCls: 'fa fa-asterisk',
        requiresAuth: true
      }, {
        to: '/dashboard/ortaggio-list',
        text: 'Ortaggio',
        iconCls: 'fa fa-leaf',
        requiresAuth: true
      }, {
        to: '/dashboard/setting',
        text: 'Impostazioni',
        iconCls: 'fa fa-cogs',
        requiresAuth: true
      }]
    };
  },
  computed: {
    isAuth: function isAuth() {
      return this.$root.isAuth;
    }
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    itemVisible: function itemVisible(item) {
      if (item.requiresAuth || item.requiresAuthType) {
        if (!this.$root.isAuth) {
          return false;
        }
        if (!this.checkAuthType(item.requiresAuthType)) {
          return false;
        }
      }
      return true;
    }
  }
});

/***/ }),

/***/ "To5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TtcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Ore di lavoro")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"date","label":"Giorno","disabled":_vm.saving},model:{value:(_vm.giorno),callback:function ($$v) {_vm.giorno=$$v},expression:"giorno"}})],1)])]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v(_vm._s(_vm.loadingText))])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-ore-lavoro",style:({'padding-bottom':'90px','max-width':'100%','max-height':Math.max(200,_vm.window.height-200)+'px'})},[_c('vue-scrolling-table',{staticClass:"table",attrs:{"deadAreaColor":"#FFF"}},[_c('template',{slot:"thead"},[_c('tr',[_c('th',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_c('b',[_vm._v("Acconto")])]),_vm._v(" "),_vm._l((_vm.lavorazioni),function(lav){return _c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(lav.lavorazione))])}),_vm._v(" "),_c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_c('b',[_vm._v("Totale")])])],2)]),_vm._v(" "),_c('template',{staticStyle:{"padding-bottom":"150px"},slot:"tbody"},[_vm._l((_vm.dipendenti),function(dip){return _c('tr',[_c('td',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}},[_vm._v(_vm._s(dip.nome)+" "+_vm._s(dip.cognome))]),_vm._v(" "),_c('td',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important","white-space":"nowrap","overflow":"visible"}},[_c('fg-input',{class:{'ore-lavoro': true,'ore-lavoro-hide-text':(_vm.acconti[dip.id]==0), 'ore-lavoro-disabled': _vm.saving},attrs:{"type":"number"},model:{value:(_vm.acconti[dip.id]),callback:function ($$v) {_vm.$set(_vm.acconti, dip.id, $$v)},expression:"acconti[dip.id]"}})],1),_vm._v(" "),_vm._l((_vm.lavorazioni),function(lav){return _c('td',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important","white-space":"nowrap","overflow":"visible"}},[_c('Orario',{class:{'ore-lavoro': true,'ore-lavoro-hide-text':(_vm.lavoro[dip.id][lav.id]==0), 'ore-lavoro-disabled': _vm.saving},model:{value:(_vm.lavoro[dip.id][lav.id]),callback:function ($$v) {_vm.$set(_vm.lavoro[dip.id], lav.id, $$v)},expression:"lavoro[dip.id][lav.id]"}})],1)}),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getTotaleDipendente(dip.id)))])],2)}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}},[_c('b',[_vm._v("Totale")])]),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}}),_vm._v(" "),_vm._l((_vm.lavorazioni),function(lav){return _c('td',{staticClass:"ore-lavoro-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getTotaleLavorazione(lav.id)))])}),_vm._v(" "),_c('td',{staticClass:"ore-lavoro-totali",staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(_vm.getTotaleGenerale()))])],2)],2)],2)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","min-height":"90px","margin-top":"-90px"}},[_c('center',{staticStyle:{"color":"red","font-weight":"bold"}},[_vm._v(_vm._s(_vm.erroreSalvataggio))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n              Salva\n            ")])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U38g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dipendente_vue__ = __webpack_require__("x2cS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6381d7ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dipendente_vue__ = __webpack_require__("5OC2");
function injectStyle (ssrContext) {
  __webpack_require__("Un3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dipendente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6381d7ef_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dipendente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UGW8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Un3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UvUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar($event)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",[(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "W21T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Ortaggi")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"","placeholder":"Cerca..."},model:{value:(_vm.pattern),callback:function ($$v) {_vm.pattern=$$v},expression:"pattern"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 table-responsive"},[_c('l-table',{staticClass:"table-hover table-striped",attrs:{"columns":_vm.ortaggiColumns,"data":_vm.ortaggi,"url":_vm.url,"pattern":_vm.pattern,"getRowClass":_vm.ortaggiRowClass},on:{"onClick":_vm.onClick}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.newOrtaggio($event)}}},[_vm._v("\n                Nuova Ortaggio\n              ")])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WOE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_vm._v(" "),_vm._t("addonLeft",[(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",[(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XJVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stf_vue_select__ = __webpack_require__("uSsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stf_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stf_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stf_vue_select_dist_lib_stf_vue_select_min_css__ = __webpack_require__("xR3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stf_vue_select_dist_lib_stf_vue_select_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stf_vue_select_dist_lib_stf_vue_select_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StfSelect: __WEBPACK_IMPORTED_MODULE_0_stf_vue_select__["StfSelect"],
    StfSelectOption: __WEBPACK_IMPORTED_MODULE_0_stf_vue_select__["StfSelectOption"]
  },
  inheritAttrs: false,
  name: 'combo-box',
  props: {
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String,
    options: Array,
    textField: String,
    placeholder: String
  },
  computed: {
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    },

    selectedText: function selectedText() {
      var _this = this;

      var selItem = this.$props.options.find(function (item) {
        return item.id === _this.$props.value;
      });
      return selItem ? this.getItemText(selItem) : '';
    }
  },
  data: function data() {
    return {
      searchString: ''
    };
  },

  methods: {
    checkFilter: function checkFilter(item) {
      if (!this.$data.searchString) {
        return true;
      } else {
        return this.getItemText(item).toUpperCase().indexOf(this.$data.searchString.toUpperCase()) !== -1;
      }
    },
    onSelect: function onSelect(item) {
      this.$emit('input', item.id);
    },
    selectFirst: function selectFirst(e) {
      var _this2 = this;

      var firstItem = this.$props.options.find(function (el) {
        return _this2.getItemText(el).toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1;
      });
      if (firstItem) {
        this.$emit('input', firstItem.id);
      } else {
        this.$emit('input', null);
      }
      this.$data.searchString = '';
    },
    getItemText: function getItemText(item) {
      if (!this.$props.textField) {
        return item.text;
      } else {
        return item[this.$props.textField];
      }
    }
  }
});

/***/ }),

/***/ "XWNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xqzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__("dtSC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e39a21_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__("6obS");
function injectStyle (ssrContext) {
  __webpack_require__("d1yP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e39a21_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YORJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_vm._v(" "),_vm._t("addonLeft",[(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]),_vm._v(" "),_c('div',{class:{'div-stf-select-not-allowed': _vm.$attrs.disabled || _vm.$attrs.readOnly}},[_c('stf-select',_vm._b({staticClass:"form-control",attrs:{"value":_vm.value,"aria-describedby":"addon-right addon-left"},on:{"input":_vm.onSelect}},'stf-select',_vm.$attrs,false),[_c('div',{attrs:{"slot":"label"},domProps:{"textContent":_vm._s(_vm.placeholder)},slot:"label"}),_vm._v(" "),_c('div',{attrs:{"slot":"value"},slot:"value"},[(_vm.value)?_c('div',[_c('span',{domProps:{"textContent":_vm._s(_vm.selectedText)}})]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"search-input"},slot:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchString),expression:"searchString"}],domProps:{"value":(_vm.searchString)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.selectFirst($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchString=$event.target.value}}})]),_vm._v(" "),_c('section',{staticClass:"options delivery_order__options"},_vm._l((_vm.options),function(item){return (_vm.checkFilter(item))?_c('stf-select-option',{key:item.id,class:{'stf-select-option_selected': item.id === _vm.value},attrs:{"value":item}},[_c('span',{domProps:{"textContent":_vm._s(_vm.getItemText(item))}})]):_vm._e()}),1)])],1),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",[(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YjFz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yt4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[(_vm.isAuth)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('span',{staticClass:"no-icon",on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("Log out")])])]):_c('li',{staticClass:"nav-item"},[_c('sidebar-link',{staticClass:"nav-link",attrs:{"to":"/login"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Log in")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_874b0e5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("AxoN");
function injectStyle (ssrContext) {
  __webpack_require__("AKoQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-874b0e5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_874b0e5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZZLa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZsdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SettingPasswordChange_vue__ = __webpack_require__("3+++");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SettingPasswordChange: __WEBPACK_IMPORTED_MODULE_0__SettingPasswordChange_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "a1YH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Checkbox: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_Inputs_Checkbox_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    LTable: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Table_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      editTooltip: 'Edit Task',
      deleteTooltip: 'Remove',
      pieChart: {
        data: {
          labels: ['40%', '20%', '40%'],
          series: [40, 20, 40]
        }
      },
      lineChart: {
        data: {
          labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
          series: [[287, 385, 490, 492, 554, 586, 698, 695], [67, 152, 143, 240, 287, 335, 435, 437], [23, 113, 67, 108, 190, 239, 307, 308]]
        },
        options: {
          low: 0,
          high: 800,
          showArea: false,
          height: '245px',
          axisX: {
            showGrid: false
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50
          }
        },
        responsiveOptions: [['screen and (max-width: 640px)', {
          axisX: {
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return value[0];
            }
          }
        }]]
      },
      barChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895], [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        },
        responsiveOptions: [['screen and (max-width: 640px)', {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function labelInterpolationFnc(value) {
              return value[0];
            }
          }
        }]]
      },
      tableData: {
        data: [{ title: 'Sign contract for "What are conference organizers afraid of?"', checked: false }, { title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true }, {
          title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
          checked: true
        }, { title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false }, { title: 'Read "Following makes Medium better"', checked: false }, { title: 'Unfollow 5 enemies from twitter', checked: false }]
      }
    };
  }
});

/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9b2118e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("HQ3I");
function injectStyle (ssrContext) {
  __webpack_require__("7KYA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9b2118e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aGhG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiepilogoTrattamenti_vue__ = __webpack_require__("Axzs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cac7d2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiepilogoTrattamenti_vue__ = __webpack_require__("MXdA");
function injectStyle (ssrContext) {
  __webpack_require__("YjFz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RiepilogoTrattamenti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cac7d2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RiepilogoTrattamenti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "agdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      username: '',
      password: '',
      stay_connected: false
    };
  },

  methods: {
    login: function login(event) {
      var me = this;
      me.$data.loading = true;
      var username = this.$data.username;
      var password = this.$data.password;
      var stayConnected = this.$data.stay_connected;
      var callBackFn = function callBackFn(success) {
        if (success === false) {
          me.$data.loading = false;
        }
      };
      this.$root.login(username, password, stayConnected, callBackFn);
    }
  }
});

/***/ }),

/***/ "bPm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("a1YH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d41705c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("+Afb");
function injectStyle (ssrContext) {
  __webpack_require__("l19Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d41705c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "baws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Accedi")]),_vm._v(" "),_c('p',[_vm._v("Inserisci le credenziali")]),_vm._v(" "),_c('form',{staticClass:"login-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('fg-input',{attrs:{"type":"password","label":"Password","placeholder":"Password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p-checkbox',{model:{value:(_vm.stay_connected),callback:function ($$v) {_vm.stay_connected=$$v},expression:"stay_connected"}},[_c('label',{staticClass:"control-label"},[_vm._v("\n                    Resta connesso\n                    ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-info btn-fill float-right",attrs:{"type":"submit","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.login($event)}}},[_vm._v("\n                  Accedi\n                ")])])])])])],2)],1)]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3",staticStyle:{"padding":"0px 30px"}},[_c('a',{attrs:{"href":"#/user-recovery"}},[_vm._v("Password dimenticata?")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea8e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("FGMu");
function injectStyle (ssrContext) {
  __webpack_require__("GjBJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ea8e9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cdY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      username: '',
      mailInviata: false
    };
  },

  methods: {
    invia: function invia(event) {
      var me = this;
      me.$data.loading = true;
      var url = "https://cortassa.ideadinamica.it/api/" + 'auth/user/recovery';
      var method = 'POST';
      var params = {
        username: me.$data.username
      };
      var successFn = function successFn(data) {
        me.$data.mailInviata = true;
        me.$data.loading = false;
      };
      var errorFn = function errorFn(message) {
        me.ajaxErrorFn(message);
        me.$data.loading = false;
      };
      me.$root.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "cxu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-stats"},[_c('div',{staticClass:"row"},[(_vm.$slots.header)?_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"icon-big text-center"},[_vm._t("header")],2)]):_vm._e(),_vm._v(" "),(_vm.$slots.content)?_c('div',{staticClass:"col-7"},[_c('div',{staticClass:"numbers"},[_vm._t("content")],2)]):_vm._e()]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d1yP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dIf/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Dati "+_vm._s(_vm.objName))]),_vm._v(" "),(_vm.oggetto.deleted_at)?_c('p',{staticClass:"card-category text-danger"},[_vm._v("Disattivato")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{attrs:{"type":"text","label":"Nome","placeholder":"Nome","disabled":_vm.readOnly},model:{value:(_vm.oggetto.nome),callback:function ($$v) {_vm.$set(_vm.oggetto, "nome", $$v)},expression:"oggetto.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataInserimento),expression:"dataInserimento"}],attrs:{"type":"date","label":"Data inserimento","disabled":true},model:{value:(_vm.dataInserimento),callback:function ($$v) {_vm.dataInserimento=$$v},expression:"dataInserimento"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataEliminazione),expression:"dataEliminazione"}],attrs:{"type":"date","label":"Data eliminazione","disabled":true},model:{value:(_vm.dataEliminazione),callback:function ($$v) {_vm.dataEliminazione=$$v},expression:"dataEliminazione"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[(_vm.saving || !_vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                  Salva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.modModifica($event)}}},[_vm._v("\n                  Modifica\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && !_vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.disattiva($event)}}},[_vm._v("\n                  Disattiva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && _vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.riattiva($event)}}},[_vm._v("\n                  Riattiva\n                ")]):_vm._e()])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5849b71b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("h3XC");
function injectStyle (ssrContext) {
  __webpack_require__("Jjqc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5849b71b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dtSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      password: '',
      password2: '',
      tokenVerificato: false,
      messaggioErrore: '',
      passwordModificata: false
    };
  },
  mounted: function mounted() {
    var me = this;
    var url = "https://cortassa.ideadinamica.it/api/" + 'auth/user/checktokenreset?token=' + me.$route.query.token;
    var method = 'POST';
    var params = {};
    var successFn = function successFn(data) {
      me.$data.tokenVerificato = true;
      me.$data.loading = false;
    };
    var errorFn = function errorFn(message) {
      me.$data.loading = false;
      if (message) {
        me.$data.messaggioErrore = message;
      } else {
        me.ajaxErrorFn(message);
      }
    };
    me.ajax(url, method, params, successFn, errorFn);
  },

  methods: {
    salva: function salva(event) {
      var me = this;
      me.$data.loading = true;
      var url = "https://cortassa.ideadinamica.it/api/" + 'auth/user/resetpassword';
      var method = 'POST';
      if (me.$data.password !== me.$data.password2) {
        me.ajaxErrorFn('Le password inserite sono differenti');
        me.$data.loading = false;
        return;
      }
      var params = {
        password: me.$data.password,
        token: me.$route.query.token
      };
      var successFn = function successFn(data) {
        me.$data.passwordModificata = true;
        me.$data.loading = false;
      };
      var errorFn = function errorFn(message) {
        me.ajaxErrorFn(message);
        me.$data.loading = false;
      };
      me.$root.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "e1sq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OreLavoro_vue__ = __webpack_require__("nRCt");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    OreLavoro: __WEBPACK_IMPORTED_MODULE_0__OreLavoro_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  computed: {}
});

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d26c35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("4dWt");
function injectStyle (ssrContext) {
  __webpack_require__("6dqi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d26c35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eKKf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'fg-input',
  props: {
    label: String,
    value: [String, Number],
    addonRightIcon: String,
    addonLeftIcon: String
  },
  computed: {
    hasIcon: function hasIcon() {
      var _$slots = this.$slots,
          addonRight = _$slots.addonRight,
          addonLeft = _$slots.addonLeft;

      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
    }
  }
});

/***/ }),

/***/ "fkBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogIn_vue__ = __webpack_require__("agdi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32379f3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogIn_vue__ = __webpack_require__("baws");
function injectStyle (ssrContext) {
  __webpack_require__("ozQP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32379f3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fuBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fvpz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FarmacoList_vue__ = __webpack_require__("luiC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b75f95a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FarmacoList_vue__ = __webpack_require__("nRiI");
function injectStyle (ssrContext) {
  __webpack_require__("58dg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FarmacoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b75f95a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FarmacoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "gVeh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Dati "+_vm._s(_vm.objName))]),_vm._v(" "),(_vm.oggetto.deleted_at)?_c('p',{staticClass:"card-category text-danger"},[_vm._v("Disattivato")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{attrs:{"type":"text","label":"Nome","placeholder":"Nome","disabled":_vm.readOnly},model:{value:(_vm.oggetto.nome),callback:function ($$v) {_vm.$set(_vm.oggetto, "nome", $$v)},expression:"oggetto.nome"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataInserimento),expression:"dataInserimento"}],attrs:{"type":"date","label":"Data inserimento","disabled":true},model:{value:(_vm.dataInserimento),callback:function ($$v) {_vm.dataInserimento=$$v},expression:"dataInserimento"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataEliminazione),expression:"dataEliminazione"}],attrs:{"type":"date","label":"Data eliminazione","disabled":true},model:{value:(_vm.dataEliminazione),callback:function ($$v) {_vm.dataEliminazione=$$v},expression:"dataEliminazione"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[(_vm.saving || !_vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                  Salva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.modModifica($event)}}},[_vm._v("\n                  Modifica\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && !_vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.disattiva($event)}}},[_vm._v("\n                  Disattiva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && _vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.riattiva($event)}}},[_vm._v("\n                  Riattiva\n                ")]):_vm._e()])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "goRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTime),expression:"displayTime"}],staticClass:"display-time",attrs:{"id":_vm.id,"type":"text","readonly":""},domProps:{"value":(_vm.displayTime)},on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown($event)},"input":function($event){if($event.target.composing){ return; }_vm.displayTime=$event.target.value}}}),_vm._v(" "),(!_vm.hideClearButton)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDropdown && _vm.showClearBtn),expression:"!showDropdown && showClearBtn"}],staticClass:"clear-btn",on:{"click":function($event){$event.stopPropagation();return _vm.clearTime($event)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown($event)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown"},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr){return _c('li',{class:{active: _vm.hour === hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){$event.stopPropagation();return _vm.select('hour', hr)}}})})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m){return _c('li',{class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){$event.stopPropagation();return _vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s){return _c('li',{class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){$event.stopPropagation();return _vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a){return _c('li',{class:{active: _vm.apm === a},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){$event.stopPropagation();return _vm.select('apm', a)}}})})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h0DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h3XC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category",staticStyle:{"padding":"15px"}},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"ct-chart",attrs:{"id":_vm.chartId}})]),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8m5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__ = __webpack_require__("MsPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Orario_vue__ = __webpack_require__("3QpA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    VueScrollingTable: __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default.a,
    Orario: __WEBPACK_IMPORTED_MODULE_2__Orario_vue__["a" /* default */]
  },
  data: function data() {
    return {
      countCaricaGiorno: 0,
      saving: false,
      erroreSalvataggio: '',
      loading: true,
      loadingText: 'Caricamento in corso...',
      backendPath: 'ore-lavoro/report-giorno',
      giorno: null,
      dipendenti: [],
      lavorazioni: [],
      lavoro: [],
      acconti: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    var me = this;
    me.$data.giorno = me.todayToString();
  },

  watch: {
    giorno: function giorno(value) {
      var me = this;
      me.caricaGiorno(value);
    }
  },
  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    resettaData: function resettaData() {
      var me = this;
      me.$data.loading = true;
      me.$data.loadingText = 'Caricamento in corso...';
      me.$data.backendPath = 'ore-lavoro/report-giorno';
      me.$data.dipendenti = [];
      me.$data.lavorazioni = [];
      me.$data.lavoro = [];
    },

    caricaGiorno: function caricaGiorno(giorno) {
      var me = this;
      me.resettaData();
      var countCaricaGiorno = ++me.$data.countCaricaGiorno;
      if (!giorno) {
        return;
      }
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + giorno;
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
          return;
        }
        var lavoro = {};
        for (var d in data.dipendenti) {
          var idD = data.dipendenti[d].id;
          lavoro[idD] = {};
          for (var l in data.lavorazioni) {
            var idL = data.lavorazioni[l].id;
            var h, m;
            if (typeof data.minuti[idD] === 'undefined' || typeof data.minuti[idD][idL] === 'undefined') {
              h = 0;
              m = 0;
            } else {
              m = data.minuti[idD][idL] % 60;
              h = (data.minuti[idD][idL] - m) / 60;
            }
            if (m < 10) {
              m = '0' + m;
            }
            if (h === 0) {
              h = '0';
            }
            lavoro[idD][idL] = h + ':' + m;
          }
        }
        me.$data.loading = false;
        me.$data.dipendenti = data.dipendenti;
        me.$data.lavorazioni = data.lavorazioni;
        me.$data.lavoro = lavoro;
        me.$data.acconti = data.acconti;
      };
      var errorFn = function errorFn(message) {
        if (typeof message === 'undefined') {
          message = 'Network Error';
        }
        me.$data.loadingText = 'Errore: ' + message;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    salva: function salva() {
      var me = this;
      me.saving = true;
      me.erroreSalvataggio = '';
      var minuti = {};
      var acconti = {};
      var giorno = me.$data.giorno;
      var lavoro = me.$data.lavoro;
      for (var idDip in lavoro) {
        for (var idLav in lavoro[idDip]) {
          if (lavoro[idDip][idLav]) {
            var min = 0;
            var oreArray = [];
            if (lavoro[idDip][idLav].indexOf(':') !== -1) {
              oreArray = lavoro[idDip][idLav].split(':');
            } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
              oreArray = lavoro[idDip][idLav].split('.');
            } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
              oreArray = lavoro[idDip][idLav].split(',');
            } else {
              oreArray = [0, lavoro[idDip][idLav]];
            }
            min = (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0);
            if (min) {
              if (typeof minuti[idDip] === 'undefined') {
                minuti[idDip] = {};
              }
              minuti[idDip][idLav] = min;
            }
          }
        }
        acconti[idDip] = me.$data.acconti[idDip];
      }
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + giorno;
      var method = 'PUT';
      var params = {
        minuti: minuti,
        acconti: acconti
      };
      var successFn = function successFn(data) {
        me.successMessage('Dati salvati');
        me.saving = false;
      };
      var errorFn = function errorFn(message) {
        if (typeof message === 'undefined') {
          message = 'Network Error';
        }
        me.$data.erroreSalvataggio = 'Errore: ' + message;
        me.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    getTotaleLavorazione: function getTotaleLavorazione(idLav) {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      for (var idDip in lavoro) {
        if (lavoro[idDip][idLav]) {
          var oreArray = [];
          if (lavoro[idDip][idLav].indexOf(':') !== -1) {
            oreArray = lavoro[idDip][idLav].split(':');
          } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
            oreArray = lavoro[idDip][idLav].split('.');
          } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
            oreArray = lavoro[idDip][idLav].split(',');
          } else {
            oreArray = [0, lavoro[idDip][idLav]];
          }
          tot += (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0);
        }
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    },
    getTotaleDipendente: function getTotaleDipendente(idDip) {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      for (var idLav in lavoro[idDip]) {
        if (lavoro[idDip][idLav]) {
          var oreArray = [];
          if (lavoro[idDip][idLav].indexOf(':') !== -1) {
            oreArray = lavoro[idDip][idLav].split(':');
          } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
            oreArray = lavoro[idDip][idLav].split('.');
          } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
            oreArray = lavoro[idDip][idLav].split(',');
          } else {
            oreArray = [0, lavoro[idDip][idLav]];
          }
          tot += (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0);
        }
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    },
    getTotaleGenerale: function getTotaleGenerale() {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      for (var idDip in lavoro) {
        for (var idLav in lavoro[idDip]) {
          if (lavoro[idDip][idLav]) {
            var oreArray = [];
            if (lavoro[idDip][idLav].indexOf(':') !== -1) {
              oreArray = lavoro[idDip][idLav].split(':');
            } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
              oreArray = lavoro[idDip][idLav].split('.');
            } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
              oreArray = lavoro[idDip][idLav].split(',');
            } else {
              oreArray = [0, lavoro[idDip][idLav]];
            }
            tot += (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0);
          }
        }
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    }
  }
});

/***/ }),

/***/ "hvJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-check",class:{disabled: _vm.disabled}},[_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.cbId}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"form-check-input",attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"form-check-sign"})]),_vm._v(" "),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iL0G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPOE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('OreLavoro')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iaKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Password")])]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),(_vm.testoPrincipale)?_c('p',[_vm._v("\n            "+_vm._s(_vm.testoPrincipale)+"\n          ")]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-xl-12"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readOnly || _vm.saving),expression:"!readOnly || saving"}],attrs:{"type":"password","label":"Vecchia password","placeholder":"Vecchia password","disabled":_vm.readOnly},model:{value:(_vm.vecchia_password),callback:function ($$v) {_vm.vecchia_password=$$v},expression:"vecchia_password"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-xl-12"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readOnly || _vm.saving),expression:"!readOnly || saving"}],attrs:{"type":"password","label":"Nuova password","placeholder":"Nuova password","disabled":_vm.readOnly},model:{value:(_vm.nuova_password),callback:function ($$v) {_vm.nuova_password=$$v},expression:"nuova_password"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-xl-12"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readOnly || _vm.saving),expression:"!readOnly || saving"}],attrs:{"type":"password","label":"Ripeti password","placeholder":"Ripeti password","disabled":_vm.readOnly},model:{value:(_vm.ripeti_password),callback:function ($$v) {_vm.ripeti_password=$$v},expression:"ripeti_password"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[(_vm.saving || !_vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                  Salva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.modModifica($event)}}},[_vm._v("\n                  Cambia\n                ")]):_vm._e()])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j4Ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Light Bootstrap Table Heading")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Created using Roboto Font Family")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h1',[_c('p',{staticClass:"category"},[_vm._v("Header 1")]),_vm._v("Light Bootstrap Table Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Header 2")]),_vm._v("Light Bootstrap Table Heading")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h3',[_c('p',{staticClass:"category"},[_vm._v("Header 3")]),_vm._v("Light Bootstrap Table Heading")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h4',[_c('p',{staticClass:"category"},[_vm._v("Header 4")]),_vm._v("Light Bootstrap Table Heading")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h5',[_c('p',{staticClass:"category"},[_vm._v("Header 5")]),_vm._v("Light Bootstrap Table Heading")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h6',[_c('p',{staticClass:"category"},[_vm._v("Header 6")]),_vm._v("Light Bootstrap Table Heading")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',[_c('span',{staticClass:"category"},[_vm._v("Paragraph")]),_vm._v("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("\n                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n              ")]),_vm._v(" "),_c('small',[_vm._v("\n                Steve Jobs, CEO Apple\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Muted Text")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Coloured Text")]),_vm._v(" "),_c('p',{staticClass:"text-primary"},[_vm._v("\n              Text Primary - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-info"},[_vm._v("\n              Text Info - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_vm._v("\n              Text Success - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("\n              Text Warning - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_vm._v("\n              Text Danger - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Small Tag")]),_vm._v("Header with small subtitle "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\".small\" is a tag for the headers")])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5ece06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("pLT5");
function injectStyle (ssrContext) {
  __webpack_require__("tIy3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5ece06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jOBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__ = __webpack_require__("UGW8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9ebda94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__ = __webpack_require__("j4Ux");
function injectStyle (ssrContext) {
  __webpack_require__("HSIw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9ebda94_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k3jd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kD4L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252bc2f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("hvJA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_252bc2f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ky6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l19Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l1zh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Recupera password")]),_vm._v(" "),(!_vm.mailInviata)?_c('p',[_vm._v("Riceverai il link per il reset della password al tuo indirizzo email")]):_vm._e(),_vm._v(" "),(!_vm.mailInviata)?_c('form',{staticClass:"login-form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username","disabled":_vm.loading},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-info btn-fill float-right",attrs:{"type":"submit","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.invia($event)}}},[_vm._v("\n                    Invia\n                  ")])])])]):_vm._e(),_vm._v(" "),(_vm.mailInviata)?_c('p',[_vm._v("Abbiamo inviato il link per il reset al tuo indirizzo email.")]):_vm._e()])],2)],1)]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3",staticStyle:{"padding":"0px 30px"}},[_c('a',{attrs:{"href":"#/login"}},[_vm._v("Torna alla pagina di login")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lBlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Dati "+_vm._s(_vm.objName))]),_vm._v(" "),(_vm.oggetto.deleted_at)?_c('p',{staticClass:"card-category text-danger"},[_vm._v("Disattivato")]):_vm._e()]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v("Caricamento in corso...")])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{attrs:{"type":"text","label":"Lavorazione","placeholder":"Lavorazione","disabled":_vm.readOnly},model:{value:(_vm.oggetto.lavorazione),callback:function ($$v) {_vm.$set(_vm.oggetto, "lavorazione", $$v)},expression:"oggetto.lavorazione"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataInserimento),expression:"dataInserimento"}],attrs:{"type":"date","label":"Data inserimento","disabled":true},model:{value:(_vm.dataInserimento),callback:function ($$v) {_vm.dataInserimento=$$v},expression:"dataInserimento"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('fg-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataEliminazione),expression:"dataEliminazione"}],attrs:{"type":"date","label":"Data eliminazione","disabled":true},model:{value:(_vm.dataEliminazione),callback:function ($$v) {_vm.dataEliminazione=$$v},expression:"dataEliminazione"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[(_vm.saving || !_vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                  Salva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.modModifica($event)}}},[_vm._v("\n                  Modifica\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && !_vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.disattiva($event)}}},[_vm._v("\n                  Disattiva\n                ")]):_vm._e(),_vm._v(" "),(!_vm.saving && _vm.readOnly && _vm.oggetto.deleted_at)?_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.riattiva($event)}}},[_vm._v("\n                  Riattiva\n                ")]):_vm._e()])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lV5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Trattamenti")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"date","label":"Giorno","disabled":_vm.saving},model:{value:(_vm.giorno),callback:function ($$v) {_vm.giorno=$$v},expression:"giorno"}})],1)])]),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"card-category"},[_c('center',[_vm._v(_vm._s(_vm.loadingText))])],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-trattamenti",style:({'padding-bottom':'90px','max-width':'100%','max-height':Math.max(200,_vm.window.height-200)+'px'})},[_c('vue-scrolling-table',{staticClass:"table",attrs:{"deadAreaColor":"#FFF"}},[_c('template',{slot:"thead"},[_c('tr',[_c('th',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important","text-transform":"none !important"}},[_vm._v("g/100L")]),_vm._v(" "),_vm._l((_vm.ortaggi),function(ortaggio){return _c('th',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important"}},[_vm._v(_vm._s(ortaggio.nome))])})],2)]),_vm._v(" "),_c('template',{staticStyle:{"padding-bottom":"150px"},slot:"tbody"},_vm._l((_vm.farmaci),function(farmaco){return _c('tr',[_c('td',{staticStyle:{"width":"160px !important","min-width":"160px !important","max-width":"160px !important"}},[_vm._v(_vm._s(farmaco.nome))]),_vm._v(" "),_vm._l((_vm.ortaggi),function(ortaggio){return _c('td',{staticStyle:{"width":"120px !important","min-width":"120px !important","max-width":"120px !important","white-space":"nowrap","overflow":"visible"}},[_c('fg-input',{class:{'trattamenti': true,'trattamenti-hide-text':(_vm.trattamento[farmaco.id][ortaggio.id]==0), 'trattamenti-disabled': _vm.saving},attrs:{"type":"number"},model:{value:(_vm.trattamento[farmaco.id][ortaggio.id]),callback:function ($$v) {_vm.$set(_vm.trattamento[farmaco.id], ortaggio.id, $$v)},expression:"trattamento[farmaco.id][ortaggio.id]"}})],1)})],2)}),0)],2)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","min-height":"90px","margin-top":"-90px"}},[_c('center',{staticStyle:{"color":"red","font-weight":"bold"}},[_vm._v(_vm._s(_vm.erroreSalvataggio))])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button","disabled":_vm.saving},on:{"click":function($event){$event.preventDefault();return _vm.salva($event)}}},[_vm._v("\n                Salva\n              ")])])]):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lk2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lsyG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotAuthorized_vue__ = __webpack_require__("/2B0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375aa791_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotAuthorized_vue__ = __webpack_require__("zN9K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotAuthorized_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375aa791_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotAuthorized_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "luiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: "https://cortassa.ideadinamica.it/api/" + 'farmaco?withTrashed=true',
      farmaciColumns: [{
        key: 'nome',
        text: 'Nome'
      }],
      farmaciRowClass: function farmaciRowClass(data) {
        return data.deleted_at ? 'text-danger' : '';
      },
      farmaci: [],
      pattern: this.$route.params.pattern
    };
  },

  methods: {
    onClick: function onClick(data) {
      this.$root.$router.push('/dashboard/farmaco/' + data.id);
    },
    newFarmaco: function newFarmaco() {
      this.$root.$router.push('/dashboard/farmaco-new');
    }
  }
});

/***/ }),

/***/ "mkZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__("ZsdD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca791a44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__("pb7O");
function injectStyle (ssrContext) {
  __webpack_require__("3y94")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca791a44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nRCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OreLavoro_vue__ = __webpack_require__("h8m5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0184d5ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OreLavoro_vue__ = __webpack_require__("TtcG");
function injectStyle (ssrContext) {
  __webpack_require__("k3jd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OreLavoro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0184d5ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OreLavoro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nRiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Farmaci")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"","placeholder":"Cerca..."},model:{value:(_vm.pattern),callback:function ($$v) {_vm.pattern=$$v},expression:"pattern"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 table-responsive"},[_c('l-table',{staticClass:"table-hover table-striped",attrs:{"columns":_vm.farmaciColumns,"data":_vm.farmaci,"url":_vm.url,"pattern":_vm.pattern,"getRowClass":_vm.farmaciRowClass},on:{"onClick":_vm.onClick}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-right"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.newFarmaco($event)}}},[_vm._v("\n                Nuovo Farmaco\n              ")])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ozQP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pLT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pb7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('SettingPasswordChange')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qX7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LTable: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Table_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: "https://cortassa.ideadinamica.it/api/" + 'ortaggio?withTrashed=true',
      ortaggiColumns: [{
        key: 'nome',
        text: 'Nome'
      }],
      ortaggiRowClass: function ortaggiRowClass(data) {
        return data.deleted_at ? 'text-danger' : '';
      },
      ortaggi: [],
      pattern: this.$route.params.pattern
    };
  },

  methods: {
    onClick: function onClick(data) {
      this.$root.$router.push('/dashboard/ortaggio/' + data.id);
    },
    newOrtaggio: function newOrtaggio() {
      this.$root.$router.push('/dashboard/ortaggio-new');
    }
  }
});

/***/ }),

/***/ "ryos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrtaggioList_vue__ = __webpack_require__("qX7j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac3ccd86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrtaggioList_vue__ = __webpack_require__("W21T");
function injectStyle (ssrContext) {
  __webpack_require__("XWNY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrtaggioList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac3ccd86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrtaggioList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s46N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s73l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupImage_vue__ = __webpack_require__("OoYB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1549ce0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupImage_vue__ = __webpack_require__("6K31");
function injectStyle (ssrContext) {
  __webpack_require__("s46N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1549ce0a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    tag: {
      type: String,
      default: 'li'
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
      this.$emit('change', this.isOpen);
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
      this.$emit('change', this.isOpen);
    }
  }
});

/***/ }),

/***/ "sXk/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tIy3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tzbD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      testoPrincipale: 'Premi su cambia per modifica la password di accesso',
      saving: false,
      loading: false,
      readOnly: true,
      vecchia_password: '',
      nuova_password: '',
      ripeti_password: ''
    };
  },

  methods: {
    modModifica: function modModifica() {
      this.$data.testoPrincipale = '';
      this.$data.readOnly = false;
    },
    salva: function salva() {
      var me = this;
      if (me.$data.nuova_password !== me.$data.ripeti_password) {
        me.ajaxErrorFn('Ripetere correttamente la nuova password');
        return false;
      }
      me.$data.readOnly = true;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + 'auth/user/changepassword';
      var method = 'POST';
      var params = {
        vecchia_password: me.$data.vecchia_password,
        nuova_password: me.$data.nuova_password
      };
      var successFn = function successFn(data) {
        me.$data.vecchia_password = '';
        me.$data.nuova_password = '';
        me.$data.ripeti_password = '';
        me.$data.testoPrincipale = 'La nuova password di accesso è stata salvata';
        me.$data.saving = false;
      };
      var errorFn = function errorFn(message) {
        me.$data.readOnly = false;
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean, Number],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54112600_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("cxu9");
function injectStyle (ssrContext) {
  __webpack_require__("To5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54112600_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vaMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__ = __webpack_require__("MsPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */],
    VueScrollingTable: __WEBPACK_IMPORTED_MODULE_1_vue_scrolling_table___default.a
  },
  data: function data() {
    return {
      countCaricaGiorno: 0,
      erroreSalvataggio: '',
      loading: true,
      loadingText: 'Caricamento in corso...',
      backendPath: 'ore-lavoro/report-mese',
      giorno: null,
      dipendenti: [],
      lavorazioni: [],
      lavoro: [],
      acconti: [],
      monthFormat: {
        stringify: function stringify(date) {
          if (date instanceof Date) {
            var tzoffset = date.getTimezoneOffset() * 60000;
            var strDate = new Date(date.getTime() - tzoffset).toISOString().substr(0, 19).replace('T', ' ');
            var anno = strDate.substr(0, 4);
            var mese = parseInt(strDate.substr(5, 2)) - 1;
            var arrayMesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
            return arrayMesi[mese] + ' ' + anno;
          }
          return '';
        },
        parse: function parse(value) {
          if (typeof value === 'string') {
            var mmaa = value.trim().split(' ');
            if (mmaa.length !== 2) {
              return null;
            }
            var anno = mmaa[1];
            var arrayMesi = ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE'];
            var meseMenoUno = arrayMesi.indexOf(mmaa[0].toUpperCase());
            if (meseMenoUno !== -1) {
              var date = new Date();
              date.setMonth(meseMenoUno);
              date.setYear(anno);
              return date;
            }
          }
          return null;
        }
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    var me = this;
    me.$data.giorno = new Date();
  },

  watch: {
    giorno: function giorno(value) {
      var me = this;
      if (value instanceof Date && value.getTime()) {
        var mese = this.dateToString(value).substr(0, 7);
        me.caricaGiorno(mese);
      } else {
        me.resettaData();
      }
    }
  },
  methods: {
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    resettaData: function resettaData() {
      var me = this;
      me.$data.loading = true;
      me.$data.loadingText = 'Caricamento in corso...';
      me.$data.backendPath = 'ore-lavoro/report-mese';
      me.$data.dipendenti = [];
      me.$data.lavorazioni = [];
      me.$data.lavoro = [];
    },

    caricaGiorno: function caricaGiorno(giorno) {
      var me = this;
      me.resettaData();
      var countCaricaGiorno = ++me.$data.countCaricaGiorno;
      if (!giorno) {
        return;
      }
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + giorno;
      var method = 'GET';
      var params = {};
      var successFn = function successFn(data) {
        if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
          return;
        }
        var lavoro = {};
        for (var d in data.dipendenti) {
          var idD = data.dipendenti[d].id;
          lavoro[idD] = {};
          for (var l in data.lavorazioni) {
            var idL = data.lavorazioni[l].id;
            if (data.minuti[idD] && data.minuti[idD][idL]) {
              lavoro[idD][idL] = data.minuti[idD][idL];
            }
          }
        }
        me.$data.loading = false;
        me.$data.dipendenti = data.dipendenti;
        me.$data.lavorazioni = data.lavorazioni;
        me.$data.lavoro = lavoro;
        me.$data.acconti = data.acconti;
      };
      var errorFn = function errorFn(message) {
        if (typeof message === 'undefined') {
          message = 'Network Error';
        }
        me.$data.loadingText = 'Errore: ' + message;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    getTotaleLavorazione: function getTotaleLavorazione(idLav) {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      for (var idDip in lavoro) {
        if (lavoro[idDip][idLav]) {
          tot += parseInt(lavoro[idDip][idLav]);
        }
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    },
    getTotaleDipendente: function getTotaleDipendente(idDip) {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      for (var idLav in lavoro[idDip]) {
        if (lavoro[idDip][idLav]) {
          tot += parseInt(lavoro[idDip][idLav]);
        }
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    },
    getCompensoDipendenteString: function getCompensoDipendenteString(dip) {
      var compenso = this.getCompensoDipendente(dip);
      if (compenso === null) {
        return '';
      }
      return this.numberToString(compenso, 2) + ' €';
    },
    getCompensoDipendente: function getCompensoDipendente(dip) {
      var idDip = dip.id;
      var lavoro = this.$data.lavoro;
      var totMinuti = 0;
      var compenso = 0;
      for (var idLav in lavoro[idDip]) {
        if (lavoro[idDip][idLav]) {
          totMinuti += parseInt(lavoro[idDip][idLav]);
        }
      }
      compenso = Math.round(100 * totMinuti * dip.paga_oraria / 60) / 100;
      compenso -= this.$data.acconti[dip.id] || 0;
      if (!compenso) {
        return null;
      }
      return compenso;
    },
    getTotaleCompensi: function getTotaleCompensi() {
      var totale = 0;
      var dipendenti = this.$data.dipendenti;
      for (var idDip in dipendenti) {
        var compenso = this.getCompensoDipendente(dipendenti[idDip]);
        if (compenso !== null) {
          totale += compenso;
        }
      }
      return this.numberToString(totale, 2) + ' €';
    },
    getTotaleDipLav: function getTotaleDipLav(idDip, idLav) {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      if (lavoro[idDip] && lavoro[idDip][idLav]) {
        tot = parseInt(lavoro[idDip][idLav]);
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    },
    getTotaleGenerale: function getTotaleGenerale() {
      var lavoro = this.$data.lavoro;
      var tot = 0;
      for (var idDip in lavoro) {
        for (var idLav in lavoro[idDip]) {
          if (lavoro[idDip][idLav]) {
            tot += parseInt(lavoro[idDip][idLav]);
          }
        }
      }
      var mTot = tot % 60;
      var hTot = (tot - mTot) / 60;
      if (mTot < 10) {
        mTot = '0' + mTot;
      }
      return hTot + ':' + mTot;
    },
    getAccontiString: function getAccontiString(dip) {
      var acconto = this.$data.acconti[dip.id];
      if (!acconto) {
        return '';
      }
      return this.numberToString(parseFloat(acconto), 2) + ' €';
    },
    generatePDF: function generatePDF(dip) {
      var dipId = typeof dip !== 'undefined' ? dip.id : '';
      var anno = this.$data.giorno.getFullYear();
      var mese = this.$data.giorno.getMonth() + 1;
      if (mese < 10) {
        mese = '0' + mese;
      }
      window.open('https://cortassa.ideadinamica.it/api/pdf/compensi/?dip=' + dipId + '&date=' + anno + '-' + mese, '_blank');
      /* window.open('https://localhost/dinamica/cortassa/api/pdf/compensi/?dip=' + dipId + '&date=' + anno + '-' + mese, '_blank') */
    },
    generatePDFLavorazioni: function generatePDFLavorazioni(lav) {
      var lavId = typeof lav !== 'undefined' ? lav.id : '';
      var anno = this.$data.giorno.getFullYear();
      var mese = this.$data.giorno.getMonth() + 1;
      if (mese < 10) {
        mese = '0' + mese;
      }
      window.open('https://cortassa.ideadinamica.it/api/pdf/lavorazioni/?lav=' + lavId + '&date=' + anno + '-' + mese, '_blank');
      /* window.open('https://localhost/dinamica/cortassa/api/pdf/lavorazioni/?lav=' + lavId + '&date=' + anno + '-' + mese, '_blank') */
    }
  }
});

/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "widG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComboBox_vue__ = __webpack_require__("XJVw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7035fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComboBox_vue__ = __webpack_require__("YORJ");
function injectStyle (ssrContext) {
  __webpack_require__("iL0G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComboBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c7035fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComboBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x2cS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
  },
  data: function data() {
    return {
      objName: 'dipendente',
      backendPath: 'dipendente',
      defaultRedirect: '/dashboard/dipendente-list',
      new: false,
      id: null,
      saving: false,
      loading: true,
      readOnly: true,
      oggetto: {}
    };
  },

  computed: {
    dataInserimento: function dataInserimento() {
      if (typeof this.oggetto.created_at === 'string') {
        return this.oggetto.created_at.substr(0, 10);
      }
      return null;
    },
    dataEliminazione: function dataEliminazione() {
      if (typeof this.oggetto.deleted_at === 'string') {
        return this.oggetto.deleted_at.substr(0, 10);
      }
      return null;
    }
  },
  mounted: function mounted() {
    var me = this;
    if (me.$route.meta.new === true) {
      me.$data.new = true;
      me.$data.loading = false;
      me.$data.readOnly = false;
    } else {
      me.$data.id = me.$route.params.id;
      me.caricaDati();
    }
  },

  methods: {
    caricaDati: function caricaDati() {
      var me = this;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'GET';
      var params = { withTrashed: true };
      var successFn = function successFn(data) {
        me.$data.loading = false;
        me.$data.oggetto = data;
      };
      var errorFn = function errorFn(message) {
        me.ajaxErrorFn(message);
        me.$root.$router.push(me.$data.defaultRedirect);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    modModifica: function modModifica() {
      this.$data.readOnly = false;
    },
    salva: function salva() {
      var me = this;
      me.$data.readOnly = true;
      me.$data.saving = true;
      var url;
      var method;
      if (me.$data.new === true) {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath;
        method = 'POST';
      } else {
        url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '?withTrashed=true';
        method = 'PUT';
      }
      var params = me.$data.oggetto;
      var successFn = function successFn(data) {
        if (me.$data.new === true) {
          me.$data.id = data.id;
          me.$data.new = false;
        }
        me.$data.oggetto = data;
        me.$data.saving = false;
        me.$root.$router.push(me.$data.defaultRedirect);
        me.successMessage('Dati ' + me.toUpperFirst(me.$data.objName) + ' salvati');
      };
      var errorFn = function errorFn(message) {
        me.$data.readOnly = false;
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    disattiva: function disattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id;
      var method = 'DELETE';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' disattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    },
    riattiva: function riattiva() {
      var me = this;
      me.$data.saving = true;
      var url = "https://cortassa.ideadinamica.it/api/" + me.$data.backendPath + '/' + me.$data.id + '/restore';
      var method = 'PUT';
      var params = {};
      var successFn = function successFn(data) {
        me.$data.oggetto = data;
        me.$data.saving = false;
        // me.$root.$router.push(me.$data.defaultRedirect)
        me.successMessage('Record ' + me.toUpperFirst(me.$data.objName) + ' riattivato');
      };
      var errorFn = function errorFn(message) {
        me.$data.saving = false;
        me.ajaxErrorFn(message);
      };
      this.ajax(url, method, params, successFn, errorFn);
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xR3j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xdlZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yiiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ynVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zN9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6 offset-xl-3"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagina riservata")])]),_vm._v(" "),_c('p',[_vm._v("La pagina che stai cercando è riservata.")]),_vm._v(" "),(_vm.isAuth)?_c('p',[_vm._v("Torna alla "),_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("pagina iniziale")])],1):_vm._e(),_vm._v(" "),(!_vm.isAuth)?_c('p',[_vm._v("Via alla "),_c('router-link',{attrs:{"to":{path:'/login'}}},[_vm._v("pagina di accesso")])],1):_vm._e()],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    routeName: function routeName() {
      return this.$route.name ? this.$route.name : '';
    },
    isAuth: function isAuth() {
      return this.$root.isAuth;
    }
  },
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7c39970af4376aa0a9bd.js